import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Modal from 'react-bootstrap/Modal';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  ClearButton,
  AsyncTypeahead,
  Typeahead,
} from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { Form } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger"; 
import Tooltip from "react-bootstrap/Tooltip";
import { addMinutes, differenceInMinutes, format, isValid, parse } from "date-fns";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { geocodeByAddress, getLatLng } from "react-places-autocomplete";

import LocationSearchInput from "../../components/commons/helpers/googleLocationSearch";
import CustomMultiSelect from "../../components/commons/helpers/customMultiSelect";
import ModalWindow from "../commons/helpers/modalWindow";
import Toast from "../commons/helpers/toast";
import deleteIcon from "../../assets/images/deleteIcon.svg";
import addIcon from "../../assets/images/plusCircleIcon.svg";
import {
  userGroupUrlCheck,
  getUserTimeZone,
} from "../../utils/userGroupUrlCheck";
import {
  shiftAddAction,
  eventGetCrewChiefCountAction,
  eventUpdateShiftAction,
  quoteAssUserListAction,
  shiftEditAction,
  eventQuoteSummaryAction,
  eventSummaryAction,
  getNextShiftSeqNumberAction,
  clientDepartmentsByEventIdAction,
  shiftCalcDistanceDeptLocAction,
} from "../../actions/eventActions";
import { keyLocationListAction } from "../../actions/settings/affiliates/locationActions";
import { crewAffSkillListAction } from "../../actions/crewActions";
import {
  clientContactListAction,
  clientDepartmentsByClientIdAction,
} from "../../actions/clientActions";
import { otherExpListAction } from "../../actions/settings/otherExpActions";
import { affiliateTravelSettingsAction } from "../../actions/settings/travelModuleActions";

import * as gLoc from "../../configs/googleConfigs";
import {
  MSG_REQUIRED,
  MSG_SHIFT_ADDED,
  MSG_START_END_DATE_VALIDATION,
  MSG_REPEAT_SHIFT_VALIDATION,
  MSG_SHIFT_ADD_ERROR,
  MSG_SHIFT_TOTAL_MSG,
  MSG_SHIFT_REPEAT_ADDED,
  MSG_SHIFT_UPDATE_PAST_TIME_ERROR,
  MSG_SHIFT_SKILL_REMOVE_ERROR,
  MSG_SHIFT_SKILL_EDIT_ERROR,
  MSG_SHIFT_QUICK_UPDATE_ERROR,
  MSG_SERVER_DATA_FETCH_ERROR,
  MSG_SHIFT_TIME_UPDATE_ERROR,
  MSG_SHIFT_LENGTH_ERROR,
  MSG_MIN_SHIFT_LENGTH_ERROR,
  MSG_SHIFT_MAX_HOURS_ERROR,
} from "../../configs/msgConfigs";
import {
  LBL_SHIFT,
  LBL_LOCATION,
  LBL_TITLE,
  LBL_SAME_LOC_AS_EVENT,
  LBL_LOC_GET_GOOGLE,
  LBL_VENUE_NAME,
  LBL_STREET_1,
  LBL_STREET_2,
  LBL_CITY,
  LBL_STATE,
  LBL_COUNTRY,
  LBL_POST_CODE,
  LBL_DEPARTMENT,
  LBL_KEY_LOCATION,
  LBL_SELECT,
  LBL_IS_REPEATING_SHIFT,
  LBL_HOURS_SHORT,
  LBL_TIME_HRS_MINS, 
  LBL_SHIFT_LENGTH,
  LBL_START_DATE_TIME,
  LBL_END_DATE_TIME,
  LBL_START_TIME,
  LBL_END_TIME,
  LBL_MINS_SHORT,
  LBL_TYPE_A_LOCATION,
  LBL_SEARCHING,
  LBL_AFFILIATE_MANAGER,
  LBL_CONTACT_FROM_CLIENT,
  LBL_REQ_CREW_COUNT,
  LBL_SKILLS,
  LBL_CHIEF_COUNT,
  LBL_TOT_NUM_RESOURCES,
  LBL_OTHER_EXPENSES_COST,
  LBL_SHIFT_NOTES,
  LBL_CHOOSE_A_CONTACT,
  LBL_TYPE_ADDRESS_GOOGLE,
  LBL_MAX_SUGGESTED,
  LBL_DATES,
  LBL_SHIFT_REPEATS_ON,
  LBL_ADD_NEW_CONTACT,
  LBL_ROLE,
  LBL_DELETE,
  LBL_BTN_ADDNEW,
  LBL_CREW_UNAVAILABLE_PART,
  LBL_CREW_UNAVAILABLE_ALL,
  LBL_SLNUM,
  LBL_CREW,
  LBL_SKILL,
  LBL_STATUS,
  LBL_AVAILABILITY,
  LBL_AVAILABLE,
  LBL_UNAVAILABLE,
  LBL_OTHER,
  LBL_TRAVEL_MODULE,
  LBL_ADD_TRAVEL_MODULE,
  LBL_TM_INCLUDE_RETURN_COST, 
  LBL_TM_MIN_TRAVEL_DIST,
  LBL_MILES,
  LBL_DISTANCE_TO_LOCATION,
  LBL_TRAVEL_TIME,
  LBL_TM_STAFF_PER_VEHICLE,
  LBL_TM_NUM_OF_VEHICLE,
  LBL_TM_TOTAL,
  LBL_TM_ACTION,
  LBL_TRAVEL_COST_TOTAL,
  LBL_MIN_DIST_EXCEEDED,
  LBL_TOTAL_TRAVEL_COST
} from "../../configs/labelConfigs";

import { LOGIN_AFFILIATE_GROUP, ENUM_MM15, ENUM_SHIFT_LENGTH_HHMM, SHIFT_LENGTH_MAX_HRS, DISABLE_LOC_DET_EDIT, SHIFT_TIME_CHANGE_ERR_PART_UNAVAILABLE, SHIFT_TIME_CHANGE_ERR_ALL_UNAVAILABLE, SCHEDULE_CREW_STATUS, ROUTE_AFFILIATE_SCHEDULE_SHIFT, TM_FIELD_DISTANCE_ID, TM_FIELD_TIME_ID, TM_FIELD_PSNGR_COUNT_ID, TM_FIELD_FLAT_AMOUNT_ID } from "../../configs/staticConfigs";

import * as types from "../../actions";
import { convertTimeFrom12To24 } from "../../utils/displayFormats";
import { formValid, checkNumColon } from "../../utils/validation";
import { titleCase } from "../../utils/changeCase";
import {
  appendVenueLoc,
  converDateToLocal,
  convertDecimalToHHMM,
  convertHHMMToDecimal,
} from "../../utils/commonUtilities";

import { shiftEditDisable } from "./eventStatusCheck";
import { format as stringFormat } from "react-string-format";
import moment from "moment";
import CustomModalHeaderStepper from "./customModalHeaderStepper";
import CustomTitle from "../commons/helpers/customTitle";


const shiftRepeatDataMaster = [
  { value: "0", label: "Mon" },
  { value: "1", label: "Tue" },
  { value: "2", label: "Wed" },
  { value: "3", label: "Thu" },
  { value: "4", label: "Fri" },
  { value: "5", label: "Sat" },
  { value: "6", label: "Sun" },
];

let userGroupData = userGroupUrlCheck(window.location);
let userGroup = userGroupData.user_group;

class ShiftAdd extends Component {
  constructor(props) {
    super(props);
    let date = new Date();
    this.state = {
      affiliateId: 0,
      editShiftId: 0,
      resetGoogleLocation: 0,
      toastMessage: "",
      toastFlag: false,
      toastSuccess: true,
      formErrors: {
        shiftTitle: "",
        department: this.props.isClientPage ? "" : MSG_REQUIRED,
        keyLocation: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
        shiftLength: "",
        startDate: "",
        endDate: "",
        startTime: "",
        endTime: "",
        affManager: this.props.isClientPage ? "" : MSG_REQUIRED,
        clientContactStaff: "",
        numCrewChief: "",
        skillsRate: MSG_REQUIRED,
        otherExpCost: "",
        shiftRepeat: "",
        venueName: "",
      },
      locGoogleCodes: {
        streetOne: "",
        streetTwo: "",
        city: "",
        state: "",
        country: "",
        postcode: "",
      },
      shiftData: {
        shiftId: "",
        eventId: "",
        shiftTitle: this.props.eventDataForShift.eventTitle
          ? this.props.eventDataForShift.eventTitle + " Shift"
          : "Shift",
        isSameEventLocation: true,
        shiftLocation: "",
        googleLocation: "",
        locationId: "",
        venueName: "",
        streetOne: "",
        streetTwo: "",
        city: null,
        state: null,
        country: null,
        postcode: null,
        department: userGroup === LOGIN_AFFILIATE_GROUP ? null : "",
        keyLocation: "",
        isShiftRepeat: false,
        shiftLength: "08:00",
        shiftRepeat: [],
        startDate: date,
        endDate: date,
        startTime: "08:00",
        endTime: "16:00",
        affManager: userGroup === LOGIN_AFFILIATE_GROUP ? null : "",
        clientContactStaff: "",
        skillsRate: null,
        otherExpCost: [],
        numResource: 0,
        numCrewChief: 0,
        maxCrewChiefNum: 0,
        shiftNotes: "",
        noLocationFound: false,
        clientId: 0,
        shiftStatus: 0,
        totalRequestedCrew: 0,
        seqNumber: 1,
        travel_cost_details: {
          minimum_travel_distance: 0,
          staff_per_vehicle: 0,
          travel_time_rounding: '00:00', 
          travel_return_cost_included: true, 
          total_travel_cost: 0,
          travel_distance_miles: 0,
          travel_duration_hh_mm: 0.0,
          total_travel_staff_count: 0,
          travel_fields: [],
          calculation_details: [],
        }
      },
      skillMultiList: [],
      otherExpMultiList: [],
      disableLocationSearch: true,
      shiftActionTitle: "Add Shift",
      isSaveNew: "", //false
      isSaveBtnEnable: true, // for disable save button during edit until any change occur
      shiftLengthError: "",
      shiftRepeatData: shiftRepeatDataMaster,
      eventClientId: 0,
      clientContactAdded: 0,
      toastMessageModal: "",
      toastFlagModal: false,
      initialValidation: false,
      toastSuccessModal: true,
      shiftTimeChangeStaffAvailData: [],
      shiftTimeChangeStaffAvailStatus: '',
      goToScheduleAfterTimeChangeAccept: false,
      goToSchduleEventId: '',
      goToScheduleShiftData: {},
      showModalShiftTimeChange: false,
      travelModuleIncluded: false,
      travelModuleSettings: {},
      shiftRepeatingDaysCount: 0,
      uncheckIncludeTravelCost: false, // USED TO UNCHECK 'INCLUDE TRAVEL COST CHECKBOX' FOR EDIT SHIFTS WITHOUT TRAVEL COST ADDED 
    };

    this.onModalFormResetShiftTimeChange = this.onModalFormResetShiftTimeChange.bind(this);
    this.modalShift = React.createRef();
    this.shiftTimeChangeModalPopShiftEdit = React.createRef();
  }

  onCloseToastModal = () => {
    this.setState({
      toastFlagModal: false,
      toastMessageModal: "",
      toastSuccessModal: false,
    });
  };

  setToasterStateModal(isEnabled, message, isSucces) {
    this.setState({
      toastFlagModal: isEnabled,
      toastMessageModal: message,
      toastSuccessModal: isSucces,
    });
    setTimeout(() => {
      this.onCloseToastModal();
    }, 3000);
  }

  refreshClientContacts = () => {
    this.props.clientContactListAction({
      clientId: this.state.eventClientId,
      column: "-id",
    });
  };

  openAddNewContact = (eventClientId) => {
    this.setState({ eventClientId: eventClientId }, () => {
      this.props.openAddClientContact(eventClientId);
    });
  };

  callAffiliateDeptSkillList = () => {
    let { shiftData, affiliateId, shiftId } = this.state;
    if (shiftData.department && affiliateId) {
      let dataObj = {
        page: 0,
        column: "skill_name",
        pageSize: "",
        clientId: shiftData.clientId,
        affId: affiliateId,
        shiftId: shiftId ? shiftId : 0,
        departmentId: shiftData.department,
      };
      this.props.crewAffSkillListAction(dataObj);
    } else {
      this.setState({ skillMultiList: [] });
    }
  };

  openShiftModal = (shiftId) => {
    let { shiftData, formErrors } = this.state;
    let { eventDataForShift, isClientPage } = this.props;

    if (!shiftId && eventDataForShift.eventTitle) {
      shiftData["shiftTitle"] = eventDataForShift.eventTitle + " Shift";
    }

    let tmpStartDate = new Date();
    if (!shiftId && eventDataForShift.startDate && new Date(eventDataForShift.startDate) > tmpStartDate) {
      tmpStartDate = new Date(eventDataForShift.startDate);
    }
    shiftData["startDate"] = tmpStartDate;
    shiftData["endDate"] = tmpStartDate;

    shiftData["clientId"] = eventDataForShift.clientId;
    shiftData["eventId"] = eventDataForShift.eventId;
    shiftData["locationId"] = eventDataForShift.location;
    shiftData["streetOne"] = eventDataForShift.streetOne
      ? eventDataForShift.streetOne
      : "";
    shiftData["streetTwo"] = eventDataForShift.streetTwo
      ? eventDataForShift.streetTwo
      : "";
    shiftData["venueName"] = eventDataForShift.venueName
      ? eventDataForShift.venueName
      : "";
    shiftData["city"] = eventDataForShift.city ? eventDataForShift.city : "";

    shiftData["googleLocation"] = eventDataForShift.googleLocation ? eventDataForShift.googleLocation : "";

    shiftData["state"] = eventDataForShift.state ? eventDataForShift.state : "";
    shiftData["country"] = eventDataForShift.country
      ? eventDataForShift.country
      : "";
    shiftData["postcode"] = eventDataForShift.postcode
      ? eventDataForShift.postcode
      : "";
    //let sDate = new Date(eventDataForShift.startDate);
    //sDate.setDate(sDate.getDate() + 1);
    //sDate.toLocaleDateString()

    // let timeZone = getUserTimeZone(window.location);
    // let sDate = converDateToLocal(
    //   eventDataForShift.startDate,
    //   "+00:00",
    //   "yyyymmddThhmmss",
    //   "-"
    // );
    // shiftData["startDate"] = sDate;
    // shiftData["endDate"] = sDate;




    // departments[0]?.id || clientDepartmentsList[0]?.id

    if (isClientPage) {
      formErrors["department"] = "";
      formErrors["affManager"] = "";
    }

    this.setState(
      {
        shiftData,
        shiftRepeatData: shiftRepeatDataMaster,
        editShiftId: shiftId,
        formErrors,
      },
      () => {
        this.props.affiliateTravelSettingsAction();
        this.props.getNextShiftSeqNumberAction(eventDataForShift.eventId);
        if (eventDataForShift.affiliateId) {
          this.setState({ affiliateId: eventDataForShift.affiliateId });
          this.props.eventGetCrewChiefCountAction(
            eventDataForShift.affiliateId
          );
          if (isClientPage) {
            this.props.clientDepartmentsByClientIdAction({
              affiliateId: eventDataForShift.affiliateId,
              clientId: eventDataForShift.clientId,
            });
          } else {
            this.props.clientDepartmentsByEventIdAction(
              eventDataForShift.eventId
            );
          }

          this.props.keyLocationListAction({
            affiliateId: eventDataForShift.affiliateId,
          });
          // SKILL API NEED DEPARTMENT ID - crewAffSkillListAction COMMENTED - 21FEB2022
          // this.props.crewAffSkillListAction({page:0,column:'skill_name',pageSize:'',clientId:eventDataForShift.clientId,affId:eventDataForShift.affiliateId,shiftId:shiftId?shiftId:0});
          this.props.otherExpListAction({
            page: 0,
            column: "name",
            affiliateId: eventDataForShift.affiliateId,
            shiftId: shiftId ? shiftId : 0,
          });
        }
        this.props.clientContactListAction({
          clientId: eventDataForShift.clientId,
          column: "-id",
        });



        if (isClientPage && eventDataForShift.affiliateId) {
          // to get affiliate managers
          this.props.quoteAssUserListAction({
            pageSize: "",
            page: 0,
            column: "-id",
            search: "",
            affiliateId: eventDataForShift.affiliateId,
          });
        } else {
          this.props.quoteAssUserListAction({
            pageSize: "",
            page: 0,
            column: "-id",
            search: "",
          });
        }
        this.modalShift.current.handleOpenModal();
        if (shiftId) {
          this.props.shiftEditAction(shiftId);
        }
      }
    );
  };

  closeShiftModal = () => {
    this.modalShift.current.handleModelClose();
  };

  renderTooltip(name, props) {
    return (
      <Tooltip
        id={name}
        style={{
          opacity: 0.8,
        }}
        {...props}
      >
        {name}
      </Tooltip>
    );
  }

  formatOtherExpData(array) {
    let otherExp = [];
    if (array.length > 0) {
      array.map((item) => {
        let expObj = {};
        expObj["value"] = item.id;
        expObj["label"] = item.name;
        expObj["info"] = item.short_description;
        expObj["inputVal"] = 0;
        otherExp.push(expObj);
        return otherExp;
      });
    }
    return otherExp;
  }

  formatSkillData(array) {
    let skill = [];
    if (array.length > 0) {
      array.map((item) => {
        let skillObj = {};
        skillObj["value"] = item.id;
        skillObj["label"] = item.skill_name;
        skillObj["inputVal"] = 0;
        skillObj["checkDisable"] = item.rated ? false : true;
        skill.push(skillObj);
        return skill;
      });
    }
    return skill;
  }

  googleLocSelect = (address) => {
    const { clientDepartmentsList } = this.props;
    let { shiftData, formErrors } = this.state;
    let locGoogleCodes = this.state.locGoogleCodes;

    geocodeByAddress(address)
      .then((results) => {
        shiftData.shiftLocation = results[0].formatted_address;
        shiftData.streetOne = "";
        shiftData.streetTwo = "";
        shiftData.city = "";
        shiftData.state = "";
        shiftData.country = "";
        shiftData.postcode = "";
        let tmpArr = [];
        tmpArr = address.split(",");
        shiftData.venueName = tmpArr[0];

        locGoogleCodes.streetOne = "";
        locGoogleCodes.streetTwo = "";
        locGoogleCodes.city = "";
        locGoogleCodes.state = "";
        locGoogleCodes.country = "";
        locGoogleCodes.postcode = "";

        let allAddress = results[0].address_components;
        let addrTypes = [];
        let foundVar = 0;
        let tmpVal = "";
        allAddress.forEach((element) => {
          addrTypes = element.types;
          foundVar = 0;
          addrTypes.forEach((item) => {
            tmpVal = element.long_name.trim().length
              ? element.long_name.trim()
              : element.short_name.trim().length
                ? element.short_name.trim()
                : "";
            if (foundVar === 0 && tmpVal !== "") {
              if (gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                foundVar = 1;
                if (shiftData["streetOne"].trim() === "")
                  shiftData["streetOne"] = tmpVal;
                else shiftData["streetOne"] += ", " + tmpVal;

                if (locGoogleCodes["streetOne"].trim() === "")
                  locGoogleCodes["streetOne"] = item;
                else locGoogleCodes["streetOne"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                foundVar = 1;
                if (shiftData["streetTwo"].trim() === "")
                  shiftData["streetTwo"] = tmpVal;
                else shiftData["streetTwo"] += ", " + tmpVal;
                if (locGoogleCodes["streetTwo"].trim() === "")
                  locGoogleCodes["streetTwo"] = item;
                else locGoogleCodes["streetTwo"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                foundVar = 1;
                if (shiftData["city"].trim() === "") shiftData["city"] = tmpVal;
                else shiftData["city"] += ", " + tmpVal;
                if (locGoogleCodes["city"].trim() === "")
                  locGoogleCodes["city"] = item;
                else locGoogleCodes["city"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                foundVar = 1;
                if (shiftData["state"].trim() === "")
                  shiftData["state"] = tmpVal;
                else shiftData["state"] += ", " + tmpVal;
                if (locGoogleCodes["state"].trim() === "")
                  locGoogleCodes["state"] = item;
                else locGoogleCodes["state"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                foundVar = 1;
                if (shiftData["country"].trim() === "")
                  shiftData["country"] = tmpVal;
                else shiftData["country"] += ", " + tmpVal;
                if (locGoogleCodes["country"].trim() === "")
                  locGoogleCodes["country"] = item;
                else locGoogleCodes["country"] += ", " + item;
              } else if (gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                foundVar = 1;
                if (shiftData["postcode"].trim() === "")
                  shiftData["postcode"] = tmpVal;
                else shiftData["postcode"] += ", " + tmpVal;
                if (locGoogleCodes["postcode"].trim() === "")
                  locGoogleCodes["postcode"] = item;
                else locGoogleCodes["postcode"] += ", " + item;
              }
            }
          });
        });
        getLatLng(results[0]).then((latLng) => {
          const googleLocation = `${latLng.lat},${latLng.lng}`;
          shiftData["googleLocation"] = googleLocation;

          if (googleLocation) {
            shiftData["department"] = this.findNearestDepartment(googleLocation, clientDepartmentsList);
          }
        });

      })
      .then(() => {
        formErrors["venueName"] = "";
        formErrors["city"] = "";
        formErrors["state"] = "";
        formErrors["country"] = "";
        formErrors["postcode"] = "";
        this.setState({
          shiftData: shiftData,
          locGoogleCodes: locGoogleCodes,
          formErrors,
          isSaveBtnEnable: true,
        });
      })
      .catch((error) => console.error("Error", error));
  };

  onHandleChange = (e) => {
    const { name } = e.target;

    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;

    let trimmedValue = "";
    if (e.target.type === "text") {
      trimmedValue = value.trim();
    }

    let { formErrors, shiftData } = this.state;
    let { eventDataForShift } = this.props;

    let tmpStartDate = new Date();
    if (!this.state.editShiftId && eventDataForShift.startDate && new Date(eventDataForShift.startDate) > tmpStartDate) {
      tmpStartDate = new Date(eventDataForShift.startDate);
    }

    switch (name) {
      case "shiftTitle":
        formErrors.shiftTitle = trimmedValue.length <= 0 ? MSG_REQUIRED : "";
        break;
      case "isShiftRepeat":
        formErrors.shiftRepeat = value === true ? MSG_REQUIRED : "";

        shiftData["shiftLength"] = "08:00";
        shiftData["startTime"] = "08:00";
        shiftData["endTime"] = "16:00";
        shiftData["startDate"] = tmpStartDate;
        shiftData["endDate"] = tmpStartDate;

        break;
      case "department":
        let locId = e.target[e.target.selectedIndex].getAttribute("data-loc");
        shiftData["keyLocation"] = locId;
        formErrors.department = locId ? "" : MSG_REQUIRED;


        const originLatLng = shiftData.googleLocation
        const destLatLng = e.target[e.target.selectedIndex].getAttribute("lat_long")


        this.props.shiftCalcDistanceDeptLocAction({
          originLatLng,
          destLatLng
        });


        break;
      case "affManager":
        formErrors.affManager =
          value.length <= 0 || Number(value) === 0 ? MSG_REQUIRED : "";
        break;
      // case 'shiftLength':
      //     formErrors.shiftLength =
      //     trimmedValue.length <=0 || decimalNumRegex.test(trimmedValue) === false
      //     ? MSG_REQUIRED
      //     : "";
      //     break;
      default:
        break;
    }

    shiftData[name] = value;

    this.setState({ formErrors, shiftData, isSaveBtnEnable: true }, () => {
      if (name === "department") {
        this.callAffiliateDeptSkillList();
      }
    });
  };

  onLoadSameEventLocation = (e) => {
    let { shiftData, formErrors } = this.state;
    let { eventDataForShift } = this.props;
    this.typeahead.clear();
    const value = e.target.checked;

    if (value) {
      shiftData["locationId"] = eventDataForShift.location;
      shiftData["venueName"] = eventDataForShift.venueName
        ? eventDataForShift.venueName
        : "";
      shiftData["streetOne"] = eventDataForShift.streetOne
        ? eventDataForShift.streetOne
        : "";
      shiftData["streetTwo"] = eventDataForShift.streetTwo
        ? eventDataForShift.streetTwo
        : "";
      shiftData["city"] = eventDataForShift.city ? eventDataForShift.city : "";
      shiftData["state"] = eventDataForShift.state
        ? eventDataForShift.state
        : "";
      shiftData["country"] = eventDataForShift.country
        ? eventDataForShift.country
        : "";
      shiftData["postcode"] = eventDataForShift.postcode
        ? eventDataForShift.postcode
        : "";
      shiftData["googleLocation"] = eventDataForShift.googleLocation
        ? eventDataForShift.googleLocation
        : "";
      formErrors["venueName"] = "";
    } else {
      shiftData["locationId"] = "";
      shiftData["venueName"] = "";
      shiftData["streetOne"] = "";
      shiftData["googleLocation"] = "";
      shiftData["streetTwo"] = "";
      shiftData["city"] = null;
      shiftData["state"] = null;
      shiftData["country"] = null;
      shiftData["postcode"] = null;
      formErrors["venueName"] = MSG_REQUIRED;
    }

    shiftData["isSameEventLocation"] = value;
    shiftData["noLocationFound"] = false;
    this.setState({
      shiftData,
      disableLocationSearch: value,
      isSaveBtnEnable: true,
      formErrors,
    });
  };

  onShiftRepeatDataChange = (selectDays) => {
    const { shiftData, formErrors } = this.state;
    let actShiftRepeatData = [];
    selectDays.forEach((item) => {
      actShiftRepeatData.push(parseInt(item.value, 10));
    });
    if (actShiftRepeatData.length > 0) {
      formErrors["shiftRepeat"] = "";
    } else {
      formErrors["shiftRepeat"] = MSG_REQUIRED;
    }
    shiftData["shiftRepeat"] = actShiftRepeatData;
    this.setState({
      shiftData,
      formErrors,
    });
  };

  onSelectSkill = (event, fieldName, index) => {
    const { value } = event.target;
    const { shiftData, formErrors } = this.state;

    // Ensure skillsRate is always an array, fallback to empty array if not
    const updatedSkillsRate = Array.isArray(shiftData.skillsRate)
      ? [...shiftData.skillsRate]
      : [];

    // Handle formErrors for skillsRate
    const updatedFormErrors = { ...formErrors }; // Create a copy to avoid mutation
    if (updatedSkillsRate.length > 0) {
      updatedFormErrors["skillsRate"] = ""; // Clear the error if skillsRate is non-empty
    } else {
      updatedFormErrors["skillsRate"] = MSG_REQUIRED; // Set error message if skillsRate is empty
    }

    // Handle updates based on the fieldName and index
    if (index !== undefined) {
      const updatedSkill = {
        ...updatedSkillsRate[index], // Spread existing data to preserve other fields
        [fieldName]: value, // Dynamically set the updated field (skill, count, or chiefs_required)
      };

      // Ensure all required fields are properly set if they were not provided
      updatedSkillsRate[index] = {
        skill: updatedSkill.skill || 0,
        count: updatedSkill.count || 0,
        chiefs_required: updatedSkill.chiefs_required || 0,
      };
    }

    // Calculate crewChiefnumber and totalSkill
    let crewChiefnumber = 0;
    const totalSkill = updatedSkillsRate.reduce((total, skill) => total + Number(skill.count), 0);

    if (this.props.crewChiefCount > 0) {
      crewChiefnumber = Math.floor(totalSkill / this.props.crewChiefCount);
    }

    // Update shiftData with calculated values
    const updatedShiftData = {
      ...shiftData,
      skillsRate: updatedSkillsRate,
      numResource: totalSkill,
      maxCrewChiefNum: crewChiefnumber,
    };

    // Update the state with the modified values
    this.setState({
      shiftData: updatedShiftData,
      formErrors: updatedFormErrors,
      isSaveBtnEnable: true,
    }, () => {
      if (fieldName === 'count') {
        this.recreateTravelStaffRows();
      }
    });
  };


  handleSkillsRateUpdate = (action, index = null) => {
    const { shiftData } = this.state;

    // Clone the existing skillsRate array
    let updatedSkillsRate = [...(shiftData.skillsRate || [])];

    if (action === "add") {
      // Check if the last entry's skill and count are filled
      const lastEntry = updatedSkillsRate[updatedSkillsRate.length - 1];

      if (!lastEntry || lastEntry.skill === "0" || !lastEntry.count) {
        return;
      }

      // Add a new empty skill entry
      updatedSkillsRate.push({
        skill: "0", // Default value for skill
        count: 0,
        chiefs_required: 0,
      });
    } else if (action === "delete" && index !== null) {
      // Remove the skill entry at the specified index
      if (updatedSkillsRate.length > 1) {
        updatedSkillsRate.splice(index, 1);
      }
    }

    const totResources = updatedSkillsRate.reduce((total, skill) => total + Number(skill.count), 0);

    // if (this.props.crewChiefCount > 0) {
    //   crewChiefnumber = Math.floor(totalSkill / this.props.crewChiefCount);
    // }

    // Update the state with the modified skillsRate array
    this.setState({
      shiftData: {
        ...shiftData,
        skillsRate: updatedSkillsRate,
        numResource: totResources,
      },
    }, () => {
      if (action === "delete" && index !== null) {
        this.recreateTravelStaffRows();
      }
    });
  };

  onOtherExpDataChange = (selectedOtherExp) => {
    const { shiftData, formErrors } = this.state;
    let actOtherExpData = [];
    let notValidCount = false;
    selectedOtherExp.forEach((item) => {
      if (item.inputVal === "" || isNaN(item.inputVal)) {
        notValidCount = true;
      }
      if (notValidCount === false) {
        actOtherExpData.push({
          other_expense: parseFloat(item.value),
          cost: item.inputVal !== "" ? parseFloat(item.inputVal) : "",
        });
      }
    });
    if (notValidCount === false) {
      formErrors["otherExpCost"] = "";
    } else {
      formErrors["otherExpCost"] = MSG_REQUIRED;
    }
    shiftData["otherExpCost"] = actOtherExpData;
    this.setState({
      shiftData,
      formErrors,
      isSaveBtnEnable: true,
    });
  };

  onStartDateChange = (date, name) => {
    let { formErrors, shiftData } = this.state;
    let startDate = "";
    if (date === "" || date === null) {
      startDate = format(new Date(), "yyyy-MM-dd");
    } else {
      startDate = format(new Date(date), "yyyy-MM-dd");
    }
    shiftData[name] = startDate;

    if (name === "startDate") { // && !shiftData.isShiftRepeat
      this.handleShiftTime("CHANGING_START_DATE_TIME", date);
    }

    shiftData["shiftLength"] = this.calculateShiftLength(
      name === "startDate"
        ? `${moment(startDate).format("YYYY-MM-DD")}T${shiftData.startTime}`
        : `${moment(shiftData.startDate).format("YYYY-MM-DD")}T${shiftData.startTime
        }`,
      name === "startDate"
        ? `${moment(shiftData.endDate).format("YYYY-MM-DD")}T${shiftData.endTime
        }`
        : `${moment(startDate).format("YYYY-MM-DD")}T${shiftData.endTime}`
    );
    if (shiftData.isShiftRepeat) {
      formErrors["shiftRepeat"] = "";
    }
    this.setState({ shiftData, formErrors, isSaveBtnEnable: true });



    if (name === "startDate") {
      this.calculateEndDateAndTime();
    }
  };

  checkMinShiftLength = (shiftLength) => {
    let { assUsers } = this.props;
    let min_shift_length = assUsers[0].affiliate_profile.min_shift_length;
    if (min_shift_length) {
      let shift_length_datetime = new Date("2020-01-01 " + shiftLength + ":00");
      let settings_length_datetime = new Date(
        "2020-01-01 " + min_shift_length + ":00"
      );
      if (settings_length_datetime > shift_length_datetime) {
        let { formErrors } = this.state;
        let shiftLengthError = stringFormat(
          MSG_MIN_SHIFT_LENGTH_ERROR,
          min_shift_length
        );
        formErrors.shiftLength = MSG_REQUIRED;
        this.setState({ shiftLengthError });
      }
    }
  };

  handleShiftTime = (name, value) => {
    let { shiftData } = this.state;
    this.setState({ shiftLengthError: '' });
    switch (name) {
      case "CHANGING_SHIFT_LENGTH":
        if (!shiftData.isShiftRepeat) {
          // Ensure shiftData.startTime is valid
          if (!shiftData.startTime || shiftData.startTime.trim() === "") {
            console.error("Invalid startTime:", shiftData.startTime);
            return;
          }

          // Ensure shiftData.startDate is valid
          let startDate = shiftData.startDate ? new Date(shiftData.startDate) : new Date();
          if (isNaN(startDate)) {
            console.error("Invalid startDate:", shiftData.startDate);
            startDate = new Date();
          }

          const [hours, minutes] = value.split(":").map(Number);
          const shiftMinutes = hours * 60 + minutes;

          // Parse startTime into Date
          const startDateTime = parse(shiftData.startTime, "HH:mm", startDate);
          if (isNaN(startDateTime)) {
            console.error("Error parsing startDateTime:", shiftData.startTime);
            return;
          }

          // Calculate new endTime
          const endDateTime = addMinutes(startDateTime, shiftMinutes);
          if (isNaN(endDateTime)) {
            console.error("Error calculating endDateTime");
            return;
          }

          // If endDateTime moves to the next day, update endDate
          let newEndDate = startDate;
          if (differenceInMinutes(endDateTime, startDateTime) > 0) {
            newEndDate = endDateTime;
          }

          shiftData.shiftLength = value;
          shiftData.endDate = newEndDate;

          // Ensure endDateTime is valid before formatting
          shiftData.endTime = isValid(endDateTime) ? format(endDateTime, "HH:mm") : "00:00";

        } else {
          // If isShiftRepeat is true, only update the endTime
          if (!shiftData.startTime || shiftData.startTime.trim() === "") {
            console.error("Invalid startTime:", shiftData.startTime);
            return;
          }

          const [hours, minutes] = value.split(":").map(Number);
          const shiftMinutes = hours * 60 + minutes;

          // Parse startTime into Date
          const startDateTime = parse(shiftData.startTime, "HH:mm", new Date());
          if (isNaN(startDateTime)) {
            console.error("Error parsing startDateTime:", shiftData.startTime);
            return;
          }

          // Calculate new endTime
          const endDateTime = addMinutes(startDateTime, shiftMinutes);
          if (isNaN(endDateTime)) {
            console.error("Error calculating endDateTime");
            return;
          }

          shiftData.shiftLength = value;
          shiftData.endTime = isValid(endDateTime) ? format(endDateTime, "HH:mm") : "00:00";
        }

        this.setState({ shiftData, isSaveBtnEnable: true });
        break;

      case "CHANGING_START_DATE_TIME":

        if (!value || isNaN(new Date(value).getTime())) {
          console.error("Invalid startDate:", value);
          return;
        }

        let newStartDate = new Date(value);

        // If shiftLength is defined, calculate new endDate and endTime
        if (shiftData.shiftLength) {
          const [hours, minutes] = shiftData.shiftLength.split(":").map(Number);
          const shiftMinutes = hours * 60 + minutes;

          // Parse startTime into Date
          const startDateTime = parse(shiftData.startTime, "HH:mm", newStartDate);
          if (!isValid(startDateTime)) {
            console.error("Error parsing startDateTime:", shiftData.startTime);
            return;
          }

          // Calculate new endTime
          const endDateTime = addMinutes(startDateTime, shiftMinutes);

          // Ensure the correct endDate
          shiftData.endDate = endDateTime;
          shiftData.endTime = format(endDateTime, "HH:mm");
        }



        shiftData.startDate = newStartDate;
        this.setState({ shiftData, isSaveBtnEnable: true });
        break;






      default:
        break;
    }
  };

  // USED TO FORMAT TIME WHILE TYPING (changing 7:00 to 07:00 format)
  onBlurTime = (time, fieldName) => {
    let { shiftData } = this.state;

    if (time) {
      let formattedTime = moment(time, ["H:mm", "HH:mm"], true); // Allows single-digit hour input
      if(fieldName==='travel_duration_hh_mm') {
        let hhmm = formattedTime.format("HH:mm"); 
        shiftData.travel_cost_details.travel_duration_hh_mm = parseFloat(hhmm.toString().replace(':','.'));
      } else {
        shiftData[fieldName] = formattedTime.format("HH:mm");
      }
      
      if (fieldName === "shiftLength") {
        this.handleShiftTime("CHANGING_SHIFT_LENGTH", formattedTime.format("HH:mm"));
      } else if (fieldName === "startTime") {
        this.handleShiftTime("CHANGING_START_DATE_TIME", parse(formattedTime.format("HH:mm"), "HH:mm", shiftData.startDate));
      } else if (fieldName === "endTime") {
        shiftData["shiftLength"] = this.calculateShiftLength(
          `${moment(shiftData.startDate).format("YYYY-MM-DD")}T${shiftData.startTime
          }`, `${moment(shiftData.endDate).format("YYYY-MM-DD")}T${formattedTime.format("HH:mm")}`
        );
      }
      if (formattedTime.isValid()) {
        this.setState({
          shiftData
        });
      } else {
        console.error("Invalid time format");
      }
    }
  };

  onHandleChangeShiftLength = (time) => {
    let { formErrors, shiftData } = this.state;

    if (time._d !== undefined) {
      let shiftLength = format(new Date(time._d), "HH:mm");

      shiftData["shiftLength"] = moment(shiftData.shiftLength, "HH:mm");

      this.handleShiftTime("CHANGING_SHIFT_LENGTH", shiftLength)

      formErrors.shiftLength = "";
      this.setState({
        shiftData,
        formErrors,
        isSaveBtnEnable: true,
        shiftLengthError: "",
      });
    } else {
      let timeStr = time.toString().trim();
      let shiftLengthError = "";
      if (!checkNumColon(timeStr)) {
        timeStr = "";
      }

      if (
        timeStr.indexOf(":") >= 0 ||
        timeStr !== "" ||
        parseInt(timeStr, 10) >= 0
      ) {
        shiftData["shiftLength"] = timeStr;
        formErrors.shiftLength = "";
      } else if (timeStr === "") {
        shiftData["shiftLength"] = "";
        shiftLengthError = MSG_SHIFT_LENGTH_ERROR;
        formErrors.shiftLength = MSG_REQUIRED;
      }
      this.setState({ shiftData, formErrors, shiftLengthError });
    }
  };

  calculateShiftLength = (
    startDateTime,
    endDateTime,
    isShiftRepeatOverride = null
  ) => {
    const { shiftData } = this.state; // Assuming shiftData is in your component's state.

    // Convert start and end datetime strings into Date objects
    const start = new Date(startDateTime);
    const end = new Date(endDateTime);

    // Ensure start and end are valid dates
    if (isNaN(start.getTime()) || isNaN(end.getTime())) {
      return "0:00";
    }

    const isShiftRepeat =
      isShiftRepeatOverride !== null
        ? isShiftRepeatOverride
        : shiftData.isShiftRepeat;

    if (isShiftRepeat) {
      // When shift is repeating, calculate the difference in time (ignoring dates)
      const startMinutes = start.getHours() * 60 + start.getMinutes();
      const endMinutes = end.getHours() * 60 + end.getMinutes();

      // Adjust for crossing midnight
      const differenceInMinutes =
        endMinutes >= startMinutes
          ? endMinutes - startMinutes
          : 24 * 60 - startMinutes + endMinutes;

      const hours = Math.floor(differenceInMinutes / 60).toString().padStart(2, "0");
      const minutes = differenceInMinutes % 60;

      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    } else {
      // When not repeating, calculate the full difference
      const differenceInMillis = end.getTime() - start.getTime();

      const shiftLengthMinutes = Math.floor(differenceInMillis / (1000 * 60));
      const hours = Math.floor(Math.abs(shiftLengthMinutes) / 60).toString().padStart(2, "0");
      const minutes = Math.abs(shiftLengthMinutes) % 60;
      const sign = differenceInMillis < 0 ? "-" : "";

      return `${sign}${hours}:${minutes.toString().padStart(2, "0")}`;
    }
  };

  onHandleChangeStartTime = (time, name) => {
    let { formErrors, shiftData } = this.state;    
    this.setState({ shiftLengthError: '' });
    if (time._d !== undefined) {
      let startTime = format(new Date(time._d), "HH:mm");
      shiftData[name] = startTime;
      const dtVal = moment(shiftData.startDate).format("YYYY-MM-DD");

      // DATE VALUE OF PARAMETER 'time' IS CURRENT DATE - SO CONVERT IT TO CURRENT SHIFT START DATE 
      // let newTimeValue = new Date(JSON.stringify(shiftData.startDate).replaceAll('"','').replaceAll("'",'').split("T")[0] + "T"+JSON.stringify(time).replaceAll('"','').replaceAll("'",'').split("T")[1]);
      let newTimeValue = new Date(dtVal + "T" + startTime);
      if (name === "startTime") { // && !shiftData.isShiftRepeat
        this.handleShiftTime("CHANGING_START_DATE_TIME", newTimeValue);
      }

      shiftData["shiftLength"] = this.calculateShiftLength(
        name === "startTime"
          ? `${moment(shiftData.startDate).format("YYYY-MM-DD")}T${startTime}`
          : `${moment(shiftData.startDate).format("YYYY-MM-DD")}T${shiftData.startTime}`,
        name === "startTime"
          ? `${moment(shiftData.endDate).format("YYYY-MM-DD")}T${shiftData.endTime
          }`
          : `${moment(shiftData.endDate).format("YYYY-MM-DD")}T${startTime}`
      );
      this.setState({ shiftData, formErrors, isSaveBtnEnable: true });
    }


  };


  calculateEndDateAndTimeBKUP = () => {
    let { formErrors, shiftData } = this.state;
    let startDate = null;
    if (shiftData.startDate === "") {
      startDate = new Date();
    } else {
      startDate = new Date(shiftData.startDate);
    }
    var s =
      shiftData.startTime === ""
        ? format(startDate, "HH:mm")
        : shiftData.startTime,
      parts = s.match(/(\d+)\:(\d+)/),
      hours = parseInt(parts[1], 10),
      minutes = parseInt(parts[2], 10);

    startDate.setHours(hours);
    startDate.setMinutes(minutes);
    startDate.setHours(startDate.getHours() + Number(shiftData.shiftLength));
    if (!shiftData.isShiftRepeat) {
      shiftData.endDate = format(startDate, "yyyy-MM-dd");
    }
    shiftData.endTime = format(startDate, "HH:mm");
    this.setState({ shiftData, formErrors });
  };

  calculateEndDateAndTime = () => {
    let { formErrors, shiftData } = this.state;
    let startDate_tmp = shiftData.startDate;
    if (shiftData.startDate === "") {
      startDate_tmp = new Date();
    } else {
      if (
        typeof startDate_tmp == "string" &&
        startDate_tmp.split("T").length > 1
      ) {
        // startDate_tmp = new Date(startDate_tmp.split('T')[0]+" 00:00:00");
        startDate_tmp = new Date(startDate_tmp.split("T")[0] + "T00:00:00");
      } else if (typeof startDate_tmp == "string") {
        // startDate_tmp = new Date(startDate_tmp + " 00:00:00");
        startDate_tmp = new Date(startDate_tmp + "T00:00:00");
      } else {
        startDate_tmp = new Date(startDate_tmp);
      }
    }
    var s =
      shiftData.startTime === ""
        ? format(startDate_tmp, "HH:mm")
        : shiftData.startTime,
      parts = s.match(/(\d+)\:(\d+)/),
      hours = parseInt(parts[1], 10),
      minutes = parseInt(parts[2], 10);
    let arrTime = shiftData.shiftLength.split(":");
    let hrs = arrTime[0] && arrTime[0] !== "" ? arrTime[0] : 0;
    let mins = arrTime[1] && arrTime[1] !== "" ? arrTime[1] : 0;
    startDate_tmp.setHours(hours);
    startDate_tmp.setMinutes(minutes + Number(mins));
    startDate_tmp.setHours(startDate_tmp.getHours() + Number(hrs));
    if (!shiftData.isShiftRepeat) {
      shiftData.endDate = startDate_tmp;
    }

    try {
      shiftData.endTime = format(startDate_tmp, "HH:mm");
    } catch (error) {
      console.error("Error formatting endTime:", error);
      shiftData.endTime = "00:00"; // Default if formatting fails
    }

    this.setState({ shiftData, formErrors });
  };

  validateRepeatShift = () => {
    let { shiftData, formErrors } = this.state;
    if (shiftData.startDate === "" || shiftData.endDate === "") {
      return false;
    }
    let startDate = new Date(
      format(new Date(shiftData.startDate), "yyyy-MM-dd")
    );
    let endDate = new Date(format(new Date(shiftData.endDate), "yyyy-MM-dd"));
    if (startDate > endDate) {
      formErrors.endDate = MSG_START_END_DATE_VALIDATION;
      this.setState(formErrors);
      return false;
    }
    let totalDateDiff = parseInt(
      (endDate - startDate) / (1000 * 60 * 60 * 24),
      10
    );
    if (totalDateDiff >= 7) {
      if (shiftData["shiftRepeat"].length > 0) {
        return true;
      } else {
        formErrors.shiftRepeat = MSG_REPEAT_SHIFT_VALIDATION;
        this.setState(formErrors);
        return false;
      }
    }
    let shiftRepeat = shiftData["shiftRepeat"];
    let isValid = false;
    let flag = true;
    while (flag) {
      if (
        shiftRepeat.indexOf(
          startDate.getDay() === 0 ? 6 : startDate.getDay() - 1
        ) !== -1
      ) {
        flag = false;
        isValid = true;
      }
      if (
        format(startDate, "yyyy-MM-dd") === format(endDate, "yyyy-MM-dd") &&
        flag
      ) {
        flag = false;
      } else {
        startDate.setDate(startDate.getDate() + 1);
      }
    }
    if (!isValid) {
      formErrors.shiftRepeat = MSG_REPEAT_SHIFT_VALIDATION;
      this.setState(formErrors);
    }
    return isValid;
  };

  onSelectLocation = (selected) => {
    if (selected.length > 0) {
      let selectedLoc = selected[0];
      let { shiftData, formErrors } = this.state;
      shiftData["locationId"] = selectedLoc.id;
      shiftData["shiftLocation"] = selectedLoc.location
        ? selectedLoc.location
        : "";
      shiftData["googleLocation"] = selectedLoc.lat_long
        ? selectedLoc.lat_long
        : "";
      shiftData["venueName"] = selectedLoc.venue ? selectedLoc.venue : "";
      shiftData["streetOne"] = selectedLoc.street1 ? selectedLoc.street1 : "";
      shiftData["streetTwo"] = selectedLoc.street2 ? selectedLoc.street2 : "";
      shiftData["city"] = selectedLoc.city ? selectedLoc.city : "";
      shiftData["state"] = selectedLoc.state ? selectedLoc.state : "";
      shiftData["country"] = selectedLoc.country ? selectedLoc.country : "";
      shiftData["postcode"] = selectedLoc.postcode ? selectedLoc.postcode : "";

      formErrors["venueName"] = "";
      formErrors["city"] = "";
      formErrors["state"] = "";
      formErrors["country"] = "";
      formErrors["postcode"] = "";

      this.setState({ shiftData, formErrors, isSaveBtnEnable: true });
    }
  };

  onModalFormReset = () => {
    if (this.state.shiftTimeChangeStaffAvailStatus && this.state.shiftTimeChangeStaffAvailStatus.trim().length > 1) {
      this.setState({
        shiftTimeChangeStaffAvailData: [], goToSchduleEventId: '', goToScheduleShiftData: {}
      });

      // ), () => {
      //   this.shiftTimeChangeModalPopShiftEdit.current.handleModelCloseOnly();
      // });      
    }
    else {

      const { eventDataForShift } = this.props;
      let tmpStartDate = new Date();
      if (!this.state.editShiftId && eventDataForShift.startDate && new Date(eventDataForShift.startDate) > tmpStartDate) {
        tmpStartDate = new Date(eventDataForShift.startDate);
      }

      this.setState({
        formErrors: {
          shiftTitle: "",
          department: this.props.isClientPage ? "" : MSG_REQUIRED,
          keyLocation: "",
          city: "",
          state: "",
          country: "",
          postcode: "",
          shiftLength: "",
          startDate: "",
          endDate: "",
          startTime: "",
          endTime: "",
          affManager: this.props.isClientPage ? "" : MSG_REQUIRED,
          clientContactStaff: "",
          numCrewChief: "",
          skillsRate: MSG_REQUIRED,
          otherExpCost: "",
          shiftRepeat: "",
          venueName: "",
        },
        locGoogleCodes: {
          streetOne: "",
          streetTwo: "",
          city: "",
          state: "",
          country: "",
          postcode: "",
        },
        shiftData: {
          shiftId: "",
          eventId: eventDataForShift.eventId,
          shiftTitle: eventDataForShift.eventTitle
            ? eventDataForShift.eventTitle + ", Shift"
            : "Shift",
          isSameEventLocation: true,
          shiftLocation: "",
          googleLocation: "",
          locationId: eventDataForShift.location,
          venueName: eventDataForShift.venueName
            ? eventDataForShift.venueName
            : "",
          streetOne: eventDataForShift.streetOne
            ? eventDataForShift.streetOne
            : "",
          streetTwo: eventDataForShift.streetTwo
            ? eventDataForShift.streetTwo
            : "",
          city: eventDataForShift.city ? eventDataForShift.city : "",
          state: eventDataForShift.state ? eventDataForShift.state : "",
          country: eventDataForShift.country ? eventDataForShift.country : "",
          postcode: eventDataForShift.postcode ? eventDataForShift.postcode : "",
          department: "",
          keyLocation: "",
          isShiftRepeat: false,
          shiftLength: "08:00",
          shiftRepeat: [],
          startDate: tmpStartDate,
          endDate: tmpStartDate,
          // startDate: new Date(eventDataForShift.startDate),
          // endDate: new Date(eventDataForShift.startDate),
          startTime: "08:00",
          endTime: "16:00",
          affManager: userGroup === LOGIN_AFFILIATE_GROUP ? null : "",
          clientContactStaff: "",
          skillsRate: null,
          otherExpCost: [],
          numResource: 0,
          numCrewChief: 0,
          shiftNotes: "",
          noLocationFound: false,
          clientId: eventDataForShift.clientId,
          totalRequestedCrew: 0,
          shiftStatus: 0,
          seqNumber: 1,
          travel_cost_details: {
            minimum_travel_distance: 0,
            staff_per_vehicle: 0,
            travel_time_rounding: '00:00',
            travel_return_cost_included: true, 
            total_travel_cost: 0,
            travel_distance_miles: 0,
            travel_duration_hh_mm: 0.0,
            total_travel_staff_count: 0,
            travel_fields: [],
            calculation_details: [],
          }
        },
        skillMultiList: [],
        otherExpMultiList: [],
        disableLocationSearch: true,
        shiftActionTitle: "Add Shift",
        isSaveBtnEnable: true,
        shiftRepeatData: shiftRepeatDataMaster,
        initialValidation: false,
        shiftRepeatingDaysCount: 0,
      });
    }
  };

  onModalFormResetShiftTimeChange = () => {

    if (this.state.shiftTimeChangeStaffAvailStatus && this.state.shiftTimeChangeStaffAvailStatus.trim().length > 1) {
      this.setState({
        shiftTimeChangeStaffAvailData: [], goToSchduleEventId: '', goToScheduleShiftData: {}
      });
      // , () => {
      //   this.shiftTimeChangeModalPopShiftEdit.current.handleModelCloseOnly();
      // });      
    }
  }

  onGetGoogleLoc = (e) => {
    let resetGoogleLocation = this.state.resetGoogleLocation + 1;
    const { name } = e.target;
    let { shiftData } = this.state;
    shiftData[name] = e.target.checked;
    this.typeahead.clear();
    shiftData["locationId"] = "";
    shiftData["venueName"] = "";
    shiftData["googleLocation"] = "";
    shiftData["streetOne"] = "";
    shiftData["streetTwo"] = "";
    shiftData["city"] = null;
    shiftData["state"] = null;
    shiftData["country"] = null;
    shiftData["postcode"] = null;
    this.setState({ shiftData, resetGoogleLocation });
  };

  onSaveShiftData = () => {
    let { shiftData, formErrors, initialValidation } = this.state;
    let { isClientPage } = this.props;
    let locationData = {};
    if (
      !isClientPage &&
      (shiftData.department === "" || !shiftData.department)
    ) {
      formErrors.department = MSG_REQUIRED;
      this.setState({ formErrors });
    }
    if (shiftData.isShiftRepeat) {
      this.validateRepeatShift();
    }
    this.checkMinShiftLength(shiftData.shiftLength);
    let shiftLength = convertHHMMToDecimal(shiftData.shiftLength);
    if (
      parseFloat(shiftLength) <= 0 ||
      shiftData.shiftLength.trim() === "" ||
      shiftData.shiftLength === "00:00"
    ) {
      formErrors.shiftLength = MSG_REQUIRED;
      this.setState({ formErrors, shiftLengthError: MSG_SHIFT_LENGTH_ERROR });
    } else if (
      parseFloat(shiftData.shiftLength) > parseFloat(SHIFT_LENGTH_MAX_HRS)
    ) {
      formErrors.shiftLength = MSG_REQUIRED;
      this.setState({
        formErrors,
        shiftLengthError: MSG_SHIFT_MAX_HOURS_ERROR,
      });
    } else if (!shiftLength) {
      formErrors.shiftLength = MSG_REQUIRED;
    } else if (
      shiftData.numResource > 0 &&
      (shiftData.skillsRate === null || shiftData.skillsRate.length === 0)
    ) {
      formErrors.skillsRate = MSG_REQUIRED;
    } else if (formValid(this.state)) {
      let timeStart = shiftData.startTime.split("_");
      let timeEnd = shiftData.endTime.split("_");
      if (shiftData.locationId === "") {
        let locName = appendVenueLoc(
          shiftData.shiftLocation,
          shiftData.venueName
        );
        locationData = {
          location: locName ? locName : "",
          venue: shiftData.venueName ? shiftData.venueName : "",
          street1: shiftData.streetOne ? shiftData.streetOne : "",
          street2: shiftData.streetTwo ? shiftData.streetTwo : "",
          city: shiftData.city ? shiftData.city : "",
          state: shiftData.state ? shiftData.state : "",
          country: shiftData.country ? shiftData.country : "",
          postcode: shiftData.postcode ? shiftData.postcode : "",
          lat_long: shiftData.googleLocation ? shiftData.googleLocation : "",
        };
      }
      let timeZone = getUserTimeZone(window.location);
      let timeZoneOffSet = timeZone.utc_offset;
      let sTime = convertTimeFrom12To24(
        timeStart[0] + ":" + timeStart[1] + " " + timeStart[2]
      ).replace("::", ":");
      let eTime = convertTimeFrom12To24(
        timeEnd[0] + ":" + timeEnd[1] + " " + timeEnd[2]
      ).replace("::", ":");
      let data = {
        ...(shiftData.locationId && {
          shift_location: parseInt(shiftData.locationId, 10),
        }),
        ...(shiftData.locationId === "" && { location_data: locationData }),
        event: parseInt(shiftData.eventId, 10),
        same_as_event_location: shiftData.isSameEventLocation,
        ...(shiftData.keyLocation !== "" && {
          key_location: Number(shiftData.keyLocation),
        }),
        ...(shiftData.department !== "" && {
          department: Number(shiftData.department),
        }),
        ...(shiftData.affManager !== "" && {
          manager: Number(shiftData.affManager),
        }),
        ...(shiftData.clientContactStaff !== "" && {
          contact_staff: Number(shiftData.clientContactStaff),
        }),
        shift_skills: shiftData.skillsRate.filter(
          item => item.skill !== null && item.skill !== 0 && item.count !== 0
        ),
        ...(!isClientPage && { expenses: shiftData.otherExpCost }),
        start_date:
          format(
            new Date(
              typeof shiftData.startDate === "string"
                ? shiftData.startDate + " 00:00:00"
                : shiftData.startDate
            ),
            "yyyy-MM-dd"
          ) +
          "T" +
          sTime +
          ":00" +
          timeZoneOffSet,
        start_time: sTime,
        end_date:
          format(
            new Date(
              typeof shiftData.endDate === "string"
                ? shiftData.endDate + " 00:00:00"
                : shiftData.endDate
            ),
            "yyyy-MM-dd"
          ) +
          "T" +
          eTime +
          ":00" +
          timeZoneOffSet,
        end_time: eTime,
        shift_notes: shiftData.shiftNotes.trim(),
        repeat_shift: shiftData.isShiftRepeat ? shiftData.shiftRepeat : [],
        shift_length: shiftLength,
        is_shift_repeat: shiftData.isShiftRepeat,
        title: shiftData.shiftTitle.trim(),
        travel_cost_details: this.state.travelModuleIncluded ? shiftData.travel_cost_details : {}
      };

      if (shiftData.shiftId === "") {
        this.props.shiftAddAction(data);
      } else if (!isNaN(shiftData.shiftId)) {
        data["id"] = shiftData.shiftId;
        data["key_location"] = Number(shiftData.keyLocation);
        data["department"] = Number(shiftData.department);
        data["manager"] = Number(shiftData.affManager);
        data["contact_staff"] = Number(shiftData.clientContactStaff);
        if (this.state.goToScheduleAfterTimeChangeAccept) {
          data["shift_time_change_accepted"] = true;
        }

        this.setState({
          shiftTimeChangeStaffAvailStatus: '', shiftTimeChangeStaffAvailData: [], goToSchduleEventId: shiftData.eventId, goToScheduleShiftData: shiftData
        }, () => {
          this.props.eventUpdateShiftAction(data);
        });

      }
      initialValidation = false;
      this.setState({ initialValidation });
    } else {
      if (shiftData.shiftTitle === null) {
        formErrors.shiftTitle = MSG_REQUIRED;
      }
      if (shiftData.affManager === null) {
        formErrors.affManager = MSG_REQUIRED;
      }
      if (shiftData.city == null) {
        formErrors.city = MSG_REQUIRED;
      }
      if (shiftData.state == null) {
        formErrors.state = MSG_REQUIRED;
      }
      if (shiftData.country == null) {
        formErrors.country = MSG_REQUIRED;
      }
      if (shiftData.postcode == null) {
        formErrors.postcode = MSG_REQUIRED;
      }
      if (shiftData.shiftLength === "" || shiftData.shiftLength === "00:00") {
        formErrors.shiftLength = MSG_REQUIRED;
      }
      if (shiftData.numCrewChief === "") {
        formErrors.numCrewChief = MSG_REQUIRED;
      }
      if (shiftData.skillsRate === null) {
        formErrors.skillsRate = MSG_REQUIRED;
      }


      initialValidation = true;
      this.setState({ formErrors, initialValidation });
    }
  };

  saveFormData = () => {
    this.setState({ isSaveNew: false, shiftTimeChangeStaffAvailStatus: '', shiftTimeChangeStaffAvailData: [], goToSchduleEventId: '', goToScheduleShiftData: {} }, () => {
      this.onSaveShiftData();
    });
  };

  saveNewFormData = () => {
    this.setState({ isSaveNew: true, shiftTimeChangeStaffAvailStatus: '', shiftTimeChangeStaffAvailData: [], goToSchduleEventId: '', goToScheduleShiftData: {} }, () => {
      this.onSaveShiftData();
    });
  };

  onAcceptShiftTimeChangeConfirm = (e, actionType) => {
    if (!isNaN(this.state.shiftData.shiftId)) {
      this.setState({ goToScheduleAfterTimeChangeAccept: true }, () => {
        this.onSaveShiftData();
        this.shiftTimeChangeModalPopShiftEdit.current.handleModelClose();
      });
    }
    this.shiftTimeChangeModalPopShiftEdit.current.handleModelClose();
  }

  handleClientContactChange = (selectedContact) => {
    let { shiftData } = this.state;
    if (selectedContact.length > 0) {
      shiftData["clientContactStaff"] = selectedContact[0].id;
    }
    this.setState({ shiftData, isSaveBtnEnable: true });
  };

  handleRemoveContact = () => {
    let { shiftData } = this.state;
    shiftData["clientContactStaff"] = "";
    this.setState({ shiftData, isSaveBtnEnable: true });
  };

  onCloseToast = () => {
    this.setState({ toastFlag: false, toastMessage: "", toastSuccess: false });
  };

  setToasterState(isEnabled, message, isSucces, delayTime = 3000) {
    this.setState({
      toastFlag: isEnabled,
      toastMessage: message,
      toastSuccess: isSucces,
    });
    setTimeout(() => {
      this.onCloseToast();
    }, delayTime);
  }

  findNearestDepartment = (googleLocation, departments) => {
    if (!googleLocation) return null;

    const [targetLat, targetLng] = googleLocation.split(",").map(Number);
    let nearestDepartment = null;
    let minDistance = Infinity;

    departments.forEach((department) => {
      const [depLat, depLng] = department.key_location_detail.location.lat_long.split(",").map(Number);

      const R = 6371; // Earth radius in kilometers
      const dLat = (depLat - targetLat) * (Math.PI / 180);
      const dLon = (depLng - targetLng) * (Math.PI / 180);

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(targetLat * (Math.PI / 180)) * Math.cos(depLat * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in kilometers

      if (distance < minDistance) {
        minDistance = distance;
        nearestDepartment = department.id;
      }
    });

    return nearestDepartment;
  };

  getRepeatingShiftDaysCount = (fromDate, toDate, repeatingDays) => {
    if (!fromDate || !toDate || repeatingDays.length === 0) return 0;

    const start = new Date(fromDate);
    const end = new Date(toDate);
    if (start > end) return 0;

    // Map your format (0=Mon, 2=Wed, 4=Fri) → JS getDay() format (Mon=1, Wed=3, Fri=5)
    const dayMap = {
      0: 1, // Mon
      1: 2, // Tue
      2: 3, // Wed
      3: 4, // Thu
      4: 5, // Fri
      5: 6, // Sat
      6: 0  // Sun
    };

    const jsDays = repeatingDays.map(day => dayMap[day]);

    let count = 0;
    const cur = new Date(start);

    while (cur <= end) {
      if (jsDays.includes(cur.getDay())) {
        count++;
      }
      cur.setDate(cur.getDate() + 1);
    }

    return count;
  }

  calculateFieldTotal = () => {

  }

  createDefaultTravelCostDetails = () => {
    const { travelModuleDistanceData } = this.props;
    let trFields = [], trCalcDet = [], afltFields = [];
    let costValue = 0, totStaffCount = 0;

    let travelDistance = this.state.shiftData.travel_cost_details.travel_distance_miles > 0 ? parseFloat(this.state.shiftData.travel_cost_details.travel_distance_miles) : Math.ceil(parseFloat(travelModuleDistanceData.distance_miles));
    let travelTime = this.state.shiftData.travel_cost_details.travel_duration_hh_mm > 0 ? parseFloat(this.state.shiftData.travel_cost_details.travel_duration_hh_mm) : parseFloat(travelModuleDistanceData.duration_hh_mm);
    let totalHrs = this.calculateTravelHours(travelTime); 

    // IF travel_fields ARE NOT EMPTY, CREATE TRAVEL FIELDS AND ADD A NEW calculation_details ITEM ALSO 
    if(this.state.travelModuleSettings?.travel_fields && this.state.travelModuleSettings?.travel_fields.length) { 
      let includeReturnCost = this.state.shiftData.travel_cost_details.travel_return_cost_included ? 2 : 1; 
      let fieldTotal = 0; 
      trFields = this.state.travelModuleSettings.travel_fields.map(trItem => {
        fieldTotal = 0; 
        if(Number(trItem.field_type)===TM_FIELD_DISTANCE_ID) {
          fieldTotal = (parseFloat(travelDistance) * parseFloat(trItem.field_value)) * includeReturnCost;
          costValue += fieldTotal;
        } else if(Number(trItem.field_type)===TM_FIELD_TIME_ID) {
          fieldTotal = (parseFloat(totalHrs) * parseFloat(trItem.field_value)) * includeReturnCost;
          costValue += fieldTotal;
        } else if(Number(trItem.field_type)===TM_FIELD_PSNGR_COUNT_ID) {
          // PASSENGER COUNT IS FOR UP AND DOWN RATES SO NO NEED TO MULTIPLY WITH RETURN CHARGES 
          fieldTotal = (parseFloat(this.state.travelModuleSettings.staff_per_vehicle) * parseFloat(trItem.field_value));
          costValue += fieldTotal;
        } else if(Number(trItem.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
          fieldTotal = parseFloat(trItem.field_value) * includeReturnCost;
          costValue += fieldTotal;
        }
        afltFields.push({field_id: trItem.id, field_type: trItem.field_type, field_rate: trItem.field_value, field_total: parseFloat(fieldTotal.toFixed(2))}); 
          
        return {field_id: trItem.id, field_name:trItem.field_name, field_type: trItem.field_type, field_value: trItem.field_value, field_total: parseFloat(fieldTotal.toFixed(2))} 
      });

      let staffCount = (parseInt(this.state.shiftData.numResource, 10) > 0 && (parseInt(this.state.shiftData.numResource, 10) < parseInt(this.state.travelModuleSettings.staff_per_vehicle, 10))) ? parseInt(this.state.shiftData.numResource, 10) : parseInt(this.state.travelModuleSettings.staff_per_vehicle, 10);
      totStaffCount += staffCount;
      trCalcDet = [
        {
          affiliate_fields: afltFields,
          staff_per_vehicle: staffCount,
          no_of_vehicles: 1,
          cost: parseFloat(costValue.toFixed(2)),
        }
      ];
    } 

    this.setState((prevState) => ({
      shiftData: {
        ...prevState.shiftData,
        travel_cost_details: {
          ...prevState.shiftData.travel_cost_details,
          minimum_travel_distance: this.state.travelModuleSettings.minimum_travel_distance,
          staff_per_vehicle: this.state.travelModuleSettings.staff_per_vehicle,
          travel_time_rounding: this.state.travelModuleSettings.travel_time_rounding, 
          travel_return_cost_included: true, 
          total_travel_cost: parseFloat(costValue.toFixed(2)),
          travel_distance_miles: parseFloat(travelDistance),
          travel_duration_hh_mm: parseFloat(travelTime),
          total_travel_staff_count: parseInt(totStaffCount, 10),
          travel_fields: trFields,
          calculation_details: trCalcDet
        },
      }
    }));
  }

  onTravelModule = (e) => {
    const value = e.target.checked;
    this.setState({
      travelModuleIncluded: value, isSaveBtnEnable: true
    }, () => {
      if (value && this.state.shiftData.travel_cost_details.calculation_details.length === 0) {
        // this.createDefaultTravelCostDetails();
        this.recreateTravelStaffRows(); 
      }
    });
  };

  resetTravelCost = () => {
    this.setState((prevState) => ({
      shiftData: {
        ...prevState.shiftData,
        travel_cost_details: {
          ...prevState.shiftData.travel_cost_details,
          minimum_travel_distance: this.state.travelModuleSettings.minimum_travel_distance,
          staff_per_vehicle: this.state.travelModuleSettings.staff_per_vehicle,
          travel_time_rounding: this.state.travelModuleSettings.travel_time_rounding, 
          travel_return_cost_included: true, 
          total_travel_cost: 0,
          total_travel_staff_count: 0,
          calculation_details: [],
        },
      }
    }));
  }

  // WHENEVER SKILL STAFF COUNT CHANGES, RECREATED TRAVEL COST DETAILS 
  recreateTravelStaffRows = () => {
    let totResourceCount = parseInt(this.state.shiftData.numResource, 10);
    if (totResourceCount === 0 || !this.state.travelModuleIncluded) {
      this.resetTravelCost();
    } else {
      const { travelModuleDistanceData } = this.props;
      let trFields = [], trCalcDet = [], afltFields = [];
      let costValue = 0, totStaffCount = 0, row2_costValue = 0;
      let staffPerVehicle = parseInt(this.state.travelModuleSettings.staff_per_vehicle, 10);
      let row1_NumVehicles = 1;
      let row1_StaffPerVehicle = staffPerVehicle;
      let row2_NumVehicles = 0, row2_StaffPerVehicle = 0;
      let travelDistance = this.state.shiftData.travel_cost_details.travel_distance_miles > 0 ? parseFloat(this.state.shiftData.travel_cost_details.travel_distance_miles) : Math.ceil(parseFloat(travelModuleDistanceData.distance_miles));
      let travelTime = this.state.shiftData.travel_cost_details.travel_duration_hh_mm > 0 ? parseFloat(this.state.shiftData.travel_cost_details.travel_duration_hh_mm) : parseFloat(travelModuleDistanceData.duration_hh_mm); 
      let totalHrs = this.calculateTravelHours(travelTime);

      if (totResourceCount <= staffPerVehicle) {
        row1_NumVehicles = 1;
        row1_StaffPerVehicle = totResourceCount-1; // staffPerVehicle IS INCLUDING DRIVER, SO REDUCE THE DRIVER FROM TOTAL STAFF COUNT
      } else if (totResourceCount > staffPerVehicle) {
        row1_NumVehicles = Math.floor(totResourceCount / staffPerVehicle);
        row1_StaffPerVehicle = staffPerVehicle-1; 
        if ((totResourceCount % staffPerVehicle) > 0) {
          row2_NumVehicles = 1;
          row2_StaffPerVehicle = (totResourceCount % staffPerVehicle)-row2_NumVehicles;
        }
      } 
      
      if(this.state.travelModuleSettings?.travel_fields && this.state.travelModuleSettings?.travel_fields.length) { 
        let includeReturnCost = this.state.shiftData.travel_cost_details.travel_return_cost_included ? 2 : 1;
        let fieldTotal = 0; 
        // CREATE FIRST ROW 
        trFields = this.state.travelModuleSettings.travel_fields.map(trItem => {
          fieldTotal = 0; 
          if(Number(trItem.field_type)===TM_FIELD_DISTANCE_ID) {
            fieldTotal = (travelDistance * parseFloat(trItem.field_value) * row1_NumVehicles) * includeReturnCost;
            costValue += fieldTotal;
          } else if(Number(trItem.field_type)===TM_FIELD_TIME_ID) {
            fieldTotal = (totalHrs * parseFloat(trItem.field_value) * row1_NumVehicles) * includeReturnCost;
            costValue += fieldTotal;
          } else if(Number(trItem.field_type)===TM_FIELD_PSNGR_COUNT_ID) {
            // PASSENGER COUNT IS FOR UP AND DOWN RATES SO NO NEED TO MULTIPLY WITH RETURN CHARGES 
            fieldTotal = (parseFloat(row1_StaffPerVehicle) * parseFloat(trItem.field_value) * row1_NumVehicles);
            costValue += fieldTotal;
          } else if(Number(trItem.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
            fieldTotal = (parseFloat(trItem.field_value) * row1_NumVehicles) * includeReturnCost; 
            costValue += fieldTotal;
          }

          afltFields.push({field_id: (trItem?.id ? trItem.id : trItem?.field_id ? trItem.field_id : 0), field_type: trItem.field_type, field_rate: trItem.field_value, field_total: parseFloat(fieldTotal.toFixed(2))}); 
          return {field_id: (trItem?.id ? trItem.id : trItem?.field_id ? trItem.field_id : 0), field_name:trItem.field_name, field_type: trItem.field_type, field_value: trItem.field_value, field_total: parseFloat(fieldTotal.toFixed(2))} 
        });

        totStaffCount += parseFloat(row1_StaffPerVehicle) * row1_NumVehicles;
        trCalcDet = [
          {
            affiliate_fields: afltFields,
            staff_per_vehicle: row1_StaffPerVehicle,
            no_of_vehicles: row1_NumVehicles,
            cost: parseFloat(costValue.toFixed(2)),
          }
        ];

        // CREATE SECOND ROW IF NEEDED  
        if(row2_NumVehicles > 0) { 
          afltFields=[];
          let fieldTotal2 = 0; 
          let tmpTrFields = this.state.travelModuleSettings.travel_fields.map(trItem => {
            fieldTotal2 = 0; 
            if(Number(trItem.field_type)===TM_FIELD_DISTANCE_ID) {
              fieldTotal2 = (travelDistance * parseFloat(trItem.field_value) * row2_NumVehicles) * includeReturnCost;
              row2_costValue += fieldTotal2; 
            } else if(Number(trItem.field_type)===TM_FIELD_TIME_ID) {
              fieldTotal2 = (totalHrs * parseFloat(trItem.field_value) * row2_NumVehicles) * includeReturnCost;
              row2_costValue += fieldTotal2; 
            } else if(Number(trItem.field_type)===TM_FIELD_PSNGR_COUNT_ID) {
              // PASSENGER COUNT IS FOR UP AND DOWN RATES SO NO NEED TO MULTIPLY WITH RETURN CHARGES 
              fieldTotal2 = (parseFloat(row2_StaffPerVehicle) * parseFloat(trItem.field_value) * row2_NumVehicles);
              row2_costValue += fieldTotal2; 
            } else if(Number(trItem.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
              fieldTotal2 = (parseFloat(trItem.field_value) * row2_NumVehicles) * includeReturnCost; 
              row2_costValue += fieldTotal2; 
            }

            afltFields.push({field_id: (trItem?.id ? trItem.id : trItem?.field_id ? trItem.field_id : 0), field_type: trItem.field_type, field_rate: trItem.field_value, field_total: parseFloat(fieldTotal2.toFixed(2))});
            return {field_id: (trItem?.id ? trItem.id : trItem?.field_id ? trItem.field_id : 0), field_name:trItem.field_name, field_type: trItem.field_type, field_value: trItem.field_value, field_total: parseFloat(fieldTotal2.toFixed(2))} 
          });

          totStaffCount += parseFloat(row2_StaffPerVehicle) * row2_NumVehicles;
          trCalcDet.push({
            affiliate_fields: afltFields,
            staff_per_vehicle: row2_StaffPerVehicle,
            no_of_vehicles: row2_NumVehicles,
            cost: parseFloat(row2_costValue.toFixed(2)),
          });
        }
      }

      const { minimum_travel_distance, staff_per_vehicle, travel_time_rounding, travel_return_cost_included } = this.state.shiftData.travel_cost_details;

      this.setState((prevState) => ({
        shiftData: {
          ...prevState.shiftData,
          travel_cost_details: {
            ...prevState.shiftData.travel_cost_details,
            minimum_travel_distance: minimum_travel_distance,
            travel_time_rounding: travel_time_rounding, 
            travel_return_cost_included: travel_return_cost_included, 
            staff_per_vehicle: staff_per_vehicle,
            total_travel_cost: parseFloat((costValue + row2_costValue).toFixed(2)),
            travel_distance_miles: travelDistance,
            travel_duration_hh_mm: travelTime,
            total_travel_staff_count: parseInt(totStaffCount, 10),
            travel_fields: trFields,
            calculation_details: trCalcDet
          },
        }
      }));

    }
  }

  recalculateTravelCost = () => {
    const { travel_cost_details } = this.state.shiftData;
    const updatedDetails = [...travel_cost_details.calculation_details];

    let totalCostValue = 0, totStaffCount = 0;
    // LOOP THROUGH calculation_details AND RECALCULATE cost
    updatedDetails.forEach((calc, cIndex) => {
      totalCostValue += parseFloat(calc.cost);;
      totStaffCount += (calc.no_of_vehicles * calc.staff_per_vehicle);
    });

    let recreateCalled = false;

    this.setState((prevState) => ({
      isSaveBtnEnable: true,
      shiftData: {
        ...prevState.shiftData,
        travel_cost_details: {
          ...prevState.shiftData.travel_cost_details,
          total_travel_cost: parseFloat(totalCostValue.toFixed(2)),
          total_travel_staff_count: totStaffCount,
        },
      }
    }
    ));

    // NEED CONFIRMATION WHETHER staffPerVehicle FIELD VALUE EDITED, REARRANGE THE TRAVEL COST VALUES 
    // , () => {
    //   if(this.state.shiftData.numResource > totStaffCount) {
    //     this.recreateTravelStaffRows(); 
    //     recreateCalled = true; 
    //   }
    // }

    // if(!recreateCalled) {
    //   setTimeout(() => {
    //     this.recreateTravelStaffRows();
    //   }, 150);
    // }
  }

  handleTravelCostFieldsChange = (fieldType, calcIndex, fieldIndex, value) => {
    const { travel_cost_details } = this.state.shiftData;
    let travelDistanceMiles = travel_cost_details.travel_distance_miles;
    let travelDurationHour = travel_cost_details.travel_duration_hh_mm;
    let travelReturnIncluded = travel_cost_details.travel_return_cost_included;
    let totalHrs = this.calculateTravelHours(travelDurationHour);

    const updatedDetails = [...travel_cost_details.calculation_details];

    let recalculate = false; 
    if (fieldType === 'travel_distance_miles' || fieldType === 'travel_duration_hh_mm' || fieldType === 'travel_return_cost_included') {
      if (fieldType === 'travel_distance_miles') {
        let distance = parseFloat(value) < 0 ? 0 : parseFloat(value); 
        travelDistanceMiles = travel_cost_details.travel_distance_miles = distance; 
        recalculate = true; 
      } else if (fieldType === 'travel_duration_hh_mm') {
        if(value?._i !== undefined) {
           travelDurationHour = travel_cost_details.travel_duration_hh_mm = parseFloat(value._i.toString().replace(':','.'));
           totalHrs = this.calculateTravelHours(travelDurationHour);
        }
        else { // IF CALLED FROM onHandleChangeTravelTime 
          travelDurationHour = travel_cost_details.travel_duration_hh_mm = parseFloat(value.toString().replace(':','.'));
          totalHrs = this.calculateTravelHours(travelDurationHour);
        }
        recalculate = true; 
      } else if (fieldType === 'travel_return_cost_included') {
        travelReturnIncluded = travel_cost_details.travel_return_cost_included = value; 
        recalculate = true; 
      }

      if(recalculate){
        let costValue = 0, fieldTotal = 0; 
        let includeReturnCost = travelReturnIncluded ? 2 : 1; 
        updatedDetails.map((cdItem, cdIndex) => {
          costValue = 0;  
          let afltFields = []; 
          cdItem.affiliate_fields.forEach((field) => {
            fieldTotal = 0;
            if(Number(field.field_type)===TM_FIELD_DISTANCE_ID) {
              fieldTotal = ((parseFloat(travelDistanceMiles) * parseFloat(field.field_rate)) * parseFloat(cdItem.no_of_vehicles)) * includeReturnCost;
              costValue += fieldTotal; 
            } else if(Number(field.field_type)===TM_FIELD_TIME_ID) {
              fieldTotal = ((parseFloat(totalHrs) * parseFloat(field.field_rate)) * parseFloat(cdItem.no_of_vehicles)) * includeReturnCost; 
              costValue += fieldTotal; 
            } else if(Number(field.field_type)===TM_FIELD_PSNGR_COUNT_ID) {
              // PASSENGER COUNT IS FOR UP AND DOWN RATES SO NO NEED TO MULTIPLY WITH RETURN CHARGES 
              fieldTotal = ((parseFloat(cdItem.staff_per_vehicle) * parseFloat(field.field_rate)) * parseFloat(cdItem.no_of_vehicles));   
              costValue += fieldTotal; 
            } else if(Number(field.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
              fieldTotal = (parseFloat(field.field_rate) * parseFloat(cdItem.no_of_vehicles)) * includeReturnCost;
              costValue += fieldTotal; 
            }
            
            afltFields.push({...field, field_total: parseFloat(fieldTotal.toFixed(2))}); 

          });

          updatedDetails[cdIndex].cost = parseFloat(costValue.toFixed(2));
          updatedDetails[cdIndex].affiliate_fields = afltFields;

        });

        // RECALCULATE TRAVEL COST TOTAL AND TRAVEL STAFF TOTAL 
        let recalculateCalled = false;
        this.setState((prevState) => ({
          isSaveBtnEnable: true,
          shiftData: {
            ...prevState.shiftData,
            travel_cost_details: {
              ...prevState.shiftData.travel_cost_details,
              travel_distance_miles: travelDistanceMiles,
              travel_duration_hh_mm: travelDurationHour,
              travel_time_rounding: travel_cost_details.travel_time_rounding, 
              travel_return_cost_included: travelReturnIncluded, 
              calculation_details: updatedDetails
            },
          }
        }, () => {
          this.recalculateTravelCost();
          recalculateCalled = true;
        }));

        if (!recalculateCalled) {
          setTimeout(() => {
            this.recalculateTravelCost();
          }, 150);
        }
      }

    }
    else {
      let staffPerVehicle = parseFloat(updatedDetails[calcIndex].staff_per_vehicle);
      let numVehicles = parseFloat(updatedDetails[calcIndex].no_of_vehicles);

      let fieldVal = parseFloat(value) < 0 ? 0 : parseFloat(value);

      if (fieldType === 'affiliate_fields') {
        let fieldValue = fieldVal.toString().trim().length > 6 ? parseFloat(fieldVal.toString().trim().substring(0, 6)) : parseFloat(fieldVal);
        updatedDetails[calcIndex].affiliate_fields[fieldIndex].field_rate = parseFloat(fieldValue);
      } else if (fieldType === 'staff_per_vehicle') {
        let fieldValue = fieldVal.toString().trim().length > 2 ? parseFloat(fieldVal.toString().trim().substring(0, 2)) : parseFloat(fieldVal);
        updatedDetails[calcIndex].staff_per_vehicle = parseFloat(fieldValue);
        staffPerVehicle = parseFloat(fieldValue);
      } else if (fieldType === 'no_of_vehicles') {
        let fieldValue = fieldVal.toString().trim().length > 2 ? parseFloat(fieldVal.toString().trim().substring(0, 2)) : parseFloat(fieldVal);
        updatedDetails[calcIndex].no_of_vehicles = parseFloat(fieldValue);
        numVehicles = parseFloat(fieldValue); 
      } 
      
      let includeReturnCost = travelReturnIncluded ? 2 : 1; 
      let costValue = 0, fieldTotal = 0; 
      let afltFields = [];
      updatedDetails[calcIndex].affiliate_fields.forEach((field) => {
        fieldTotal = 0;
        if(Number(field.field_type)===TM_FIELD_DISTANCE_ID) {
          fieldTotal = ((parseFloat(travel_cost_details.travel_distance_miles) * parseFloat(field.field_rate)) * parseFloat(numVehicles)) * includeReturnCost;
          costValue += fieldTotal;
        } else if(Number(field.field_type)===TM_FIELD_TIME_ID) { 
          fieldTotal = ((parseFloat(totalHrs) * parseFloat(field.field_rate)) * parseFloat(numVehicles)) * includeReturnCost;
          costValue += fieldTotal; 
        } else if(Number(field.field_type)===TM_FIELD_PSNGR_COUNT_ID) {
          // PASSENGER COUNT IS FOR UP AND DOWN RATES SO NO NEED TO MULTIPLY WITH RETURN CHARGES 
          fieldTotal = ((parseFloat(staffPerVehicle) * parseFloat(field.field_rate)) * parseFloat(numVehicles)); 
          costValue += fieldTotal;
        } else if(Number(field.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
          fieldTotal = (parseFloat(field.field_rate) * parseFloat(numVehicles)) * includeReturnCost;
          costValue += fieldTotal; 
        }
        afltFields.push({...field, field_total: parseFloat(fieldTotal.toFixed(2))}); 
      });

      updatedDetails[calcIndex].cost = parseFloat(costValue.toFixed(2)); 
      updatedDetails[calcIndex].affiliate_fields = afltFields;

      // RECALCULATE TRAVEL COST TOTAL AND TRAVEL STAFF TOTAL 
      let recalculateCalled = false;
      this.setState((prevState) => ({
        isSaveBtnEnable: true,
        shiftData: {
          ...prevState.shiftData,
          travel_cost_details: {
            ...prevState.shiftData.travel_cost_details,
            travel_distance_miles: travelDistanceMiles,
            travel_duration_hh_mm: travelDurationHour,
            travel_time_rounding: travel_cost_details.travel_time_rounding, 
            travel_return_cost_included: travelReturnIncluded, 
            calculation_details: updatedDetails
          },
        }
      }, () => {
        this.recalculateTravelCost();
        recalculateCalled = true;
      }));

      if (!recalculateCalled) {
        setTimeout(() => {
          this.recalculateTravelCost();
        }, 150);
      }
    }
  };

  onHandleChangeTravelTime = (time) => {
    let { shiftData } = this.state;
    if (time._d !== undefined) {
      let travelTime = format(new Date(time._d), "HH:mm");
      shiftData.travel_cost_details.travel_duration_hh_mm = parseFloat(travelTime.toString().replace(':','.')).toFixed(2); 


      this.setState({
        shiftData,
        isSaveBtnEnable: true,
      }, () => {
        this.handleTravelCostFieldsChange('travel_duration_hh_mm',0,0,travelTime); 
      });
    } else {
      let timeStr = time.toString().trim();
      if (!checkNumColon(timeStr)) {
        timeStr = "";
      }

      if (timeStr.indexOf(":") >= 0 || timeStr !== "" || parseFloat(timeStr) >= 0) { 
        shiftData.travel_cost_details.travel_duration_hh_mm = parseFloat(timeStr.toString().replace(':','.')).toFixed(2); 
      } else if (timeStr === "") {
        shiftData.travel_cost_details.travel_duration_hh_mm = 0.00; 
      }
      this.setState({ shiftData,
        isSaveBtnEnable: true, }, () => {
        this.handleTravelCostFieldsChange('travel_duration_hh_mm',0,0,timeStr); 
      });
    }
  };

  onTravelCostAddNewRow = () => {
    const { travel_cost_details } = this.state.shiftData;
    let totalHrs = this.calculateTravelHours(travel_cost_details.travel_duration_hh_mm);
    let includeReturnCost = travel_cost_details.travel_return_cost_included ? 2 : 1;
    this.setState((prevState) => {
      const lastDetail = prevState.shiftData.travel_cost_details.calculation_details.slice(-1)[0];
      const remainingStaffCount = (parseInt(this.state.shiftData.numResource, 10) - parseInt(travel_cost_details.total_travel_staff_count, 10));
      let staffPerVehicle = remainingStaffCount < parseInt(this.state.travelModuleSettings.staff_per_vehicle, 10) ? remainingStaffCount : parseInt(this.state.travelModuleSettings.staff_per_vehicle, 10);

      let costValue = 0;
      let numVehicles = 1;
      lastDetail.affiliate_fields.forEach((field) => {
        if(Number(field.field_type)===TM_FIELD_DISTANCE_ID) {
          costValue += ((parseFloat(travel_cost_details.travel_distance_miles) * parseFloat(field.field_rate)) * parseFloat(numVehicles)) * includeReturnCost;
        } else if(Number(field.field_type)===TM_FIELD_TIME_ID) {
          costValue += ((parseFloat(totalHrs) * parseFloat(field.field_rate)) * parseFloat(numVehicles)) * includeReturnCost;
        } else if(Number(field.field_type)===TM_FIELD_PSNGR_COUNT_ID) {
          // PASSENGER COUNT IS FOR UP AND DOWN RATES SO NO NEED TO MULTIPLY WITH RETURN CHARGES 
          costValue += ((parseFloat(staffPerVehicle) * parseFloat(field.field_rate)) * parseFloat(numVehicles)); 
        } else if(Number(field.field_type)===TM_FIELD_FLAT_AMOUNT_ID) {
          costValue += (parseFloat(field.field_rate) * parseFloat(numVehicles)) * includeReturnCost;
        }
      });

      // Deep clone the last object to avoid direct reference
      const newDetail = {
        ...lastDetail,
        staff_per_vehicle: staffPerVehicle,
        no_of_vehicles: numVehicles,
        cost: parseFloat(costValue.toFixed(2)),
        affiliate_fields: lastDetail.affiliate_fields.map(field => ({ ...field })),
      };

      return {
        shiftData: {
          ...prevState.shiftData,
          travel_cost_details: {
            ...prevState.travel_cost_details,
            travel_distance_miles: travel_cost_details.travel_distance_miles,
            travel_duration_hh_mm: travel_cost_details.travel_duration_hh_mm,
            travel_time_rounding: travel_cost_details.travel_time_rounding, 
            travel_return_cost_included: travel_cost_details.travel_return_cost_included, 
            travel_fields: travel_cost_details.travel_fields,
            calculation_details: [...prevState.shiftData.travel_cost_details.calculation_details, newDetail],
          },
        }
      };
    }, () => {
      this.recalculateTravelCost();
    });
  }

  onTravelCostDeleteRow = (indexToDelete) => {
    const { travel_cost_details } = this.state.shiftData;
    this.setState((prevState) => {
      const updatedDetails = prevState.shiftData.travel_cost_details.calculation_details.filter(
        (_, index) => index !== indexToDelete
      );

      return {
        shiftData: {
          ...prevState.shiftData,
          travel_cost_details: {
            ...prevState.travel_cost_details,
            travel_distance_miles: travel_cost_details.travel_distance_miles,
            travel_duration_hh_mm: travel_cost_details.travel_duration_hh_mm,
            travel_time_rounding: travel_cost_details.travel_time_rounding, 
            travel_return_cost_included: travel_cost_details.travel_return_cost_included, 
            travel_fields: travel_cost_details.travel_fields,
            calculation_details: updatedDetails,
          },
        }
      };
    }, () => {
      this.recalculateTravelCost();
    });
  };

  componentDidUpdate(prevProps, next) {
    const {
      subactivity,
      errorData,
      status,
      otherExps,
      skillList,
      shiftDetails,
      shiftAddData,
      isClientPage,
      isDuplicate,
      eventDataForShift,
      newClientContactAdded,
      departments,
      eventDeptActivity,
      clientDeptActivity,
      clientDepartmentsList,
      travelModuleDistanceData,
      travelModuleActivity,
      affiliateTravelSettings
    } = this.props;
    let clientContactAdded = this.state.clientContactAdded;

    if (Number(newClientContactAdded) > Number(clientContactAdded)) {
      this.setState({ clientContactAdded: newClientContactAdded }, () => {
        this.refreshClientContacts();
      });
    }

    if (clientDeptActivity && clientDeptActivity !== prevProps.clientDeptActivity) {
      let arrClientDeptResp = clientDeptActivity.split("~~");
      if (arrClientDeptResp[0] === types.CLIENT_DEPARTMENTS_LIST_SUCCESS) {
        // (clientDepartmentsList.length === 1 || (isClientPage && clientDepartmentsList.length)) 
        if (Array.isArray(clientDepartmentsList) && clientDepartmentsList.length) {
          let shiftData = this.state.shiftData;
          let formErrors = this.state.formErrors;
          // IF ONLY ONE DEPARTMENT IS THERE,  SET THAT AS THE SHIFT DEPT, OTHERWISE SET THE NEAREST DEPT AS THE SHIFT DEPT
          if (clientDepartmentsList.length === 1 || shiftData.googleLocation == "") {
            shiftData["department"] = clientDepartmentsList[0].id;
            shiftData["keyLocation"] = clientDepartmentsList[0].key_location;
            formErrors["department"] = "";
            this.setState({ shiftData, formErrors }, () => {
              this.callAffiliateDeptSkillList();
            });
            // CALCULATE TIME AND DISTANCE BETWEEN LOCATION AND DEPARTMENT 
            if (shiftData.googleLocation !== "") {
              const originLatLng = shiftData.googleLocation
              const destLatLng = clientDepartmentsList[0].key_location_detail.location.lat_long;
              this.props.shiftCalcDistanceDeptLocAction({ originLatLng, destLatLng });
            }
          } else if (clientDepartmentsList.length > 1 && shiftData.googleLocation !== "") {
            shiftData["department"] = this.findNearestDepartment(shiftData.googleLocation, clientDepartmentsList);
            if (shiftData["department"]) {
              let selDept = clientDepartmentsList.find(it => Number(it.id) === Number(shiftData["department"]));
              shiftData["keyLocation"] = selDept.key_location;
              formErrors["department"] = "";
              this.setState({ shiftData, formErrors }, () => {
                this.callAffiliateDeptSkillList();
              });
              const originLatLng = shiftData.googleLocation
              const destLatLng = selDept.key_location_detail.location.lat_long;
              this.props.shiftCalcDistanceDeptLocAction({ originLatLng, destLatLng });
            }
          }
        }
      }
    }

    if (eventDeptActivity && eventDeptActivity !== prevProps.eventDeptActivity) {
      let arrDeptResp = eventDeptActivity.split("~~");
      if (arrDeptResp[0] === types.EVENT_CLIENT_DEPARTMENTS_LIST_SUCCESS) {
        if (departments && Array.isArray(departments) && departments.length > 0) {
          let shiftData = this.state.shiftData;
          let formErrors = this.state.formErrors;
          if (departments.length === 1 || shiftData.googleLocation == "") {
            shiftData["department"] = departments[0].id;
            shiftData["keyLocation"] = departments[0].key_location;
            formErrors["department"] = "";
            this.setState({ shiftData, formErrors }, () => {
              this.callAffiliateDeptSkillList();
            });
            // CALCULATE TIME AND DISTANCE BETWEEN LOCATION AND DEPARTMENT 
            if (shiftData.googleLocation !== "") {
              const originLatLng = shiftData.googleLocation
              const destLatLng = departments[0].key_location_detail.location.lat_long;
              this.props.shiftCalcDistanceDeptLocAction({ originLatLng, destLatLng });
            }
          } else if (departments.length > 1 && shiftData.googleLocation !== "") {
            shiftData["department"] = this.findNearestDepartment(shiftData.googleLocation, departments);
            if (shiftData["department"]) {
              let selDept = departments.find(it => Number(it.id) === Number(shiftData["department"]));
              shiftData["keyLocation"] = selDept.key_location;
              formErrors["department"] = "";
              this.setState({ shiftData, formErrors }, () => {
                this.callAffiliateDeptSkillList();
              });
              // CALCULATE TIME AND DISTANCE BETWEEN LOCATION AND DEPARTMENT 
              const originLatLng = shiftData.googleLocation
              const destLatLng = selDept.key_location_detail.location.lat_long;
              this.props.shiftCalcDistanceDeptLocAction({ originLatLng, destLatLng });
            }
          }
        }
      }
    }

    const { shiftData } = this.state;
    if (subactivity && subactivity !== prevProps.subactivity) {
      let arrResp = subactivity.split("~~");
      let actString = arrResp[0];
      // scheduleShift FUNCTION IS PASSING FROM shiftListComponent and eventDetails
      // IF THIS PAGE CALLED FROM shiftListsPage
      if (actString === types.EVENT_SHIFT_UPDATE_SUCCESS && this.state.goToScheduleAfterTimeChangeAccept && this.props.scheduleShift && (this.props.shiftListsPage || this.props.eventDetails)) {
        this.props.scheduleShift(shiftData.eventId, shiftData, this.state.goToScheduleAfterTimeChangeAccept);
      }
      else if (actString === types.EVENT_SHIFT_UPDATE_ERROR) {
        if (this.state.shiftTimeChangeStaffAvailStatus === '' && this.props.errorData && this.props.errorData?.availability && this.props.errorData?.staffs) {
          this.setState({ shiftTimeChangeStaffAvailStatus: this.props.errorData.availability, shiftTimeChangeStaffAvailData: this.props.errorData.staffs, goToScheduleAfterTimeChangeAccept: false }, () => {
            this.shiftTimeChangeModalPopShiftEdit.current.handleOpenModal();
          });
        } else {
          if (
            errorData &&
            errorData.skills_cannot_remove &&
            Array.isArray(errorData.skills_cannot_remove)
          ) {
            let skillNames = "";
            let sepVar = "";
            if (errorData.skills_cannot_remove.length > 0) {
              errorData.skills_cannot_remove.forEach((skillId) => {
                skillNames += sepVar + skillId.skill_name;
                sepVar = ", ";
              });
            }
            let msgStr = MSG_SHIFT_SKILL_REMOVE_ERROR + skillNames;
            this.setToasterState(true, msgStr, false);
          } else if (
            errorData.unavailable_crews &&
            Array.isArray(errorData.unavailable_crews)
          ) {
            let crewNames = "";
            let sepVar = "";
            if (errorData.unavailable_crews.length > 0) {
              errorData.unavailable_crews.forEach((crew) => {
                crewNames += sepVar + crew.crew_name;
                sepVar = ", ";
              });
            }
            let errMsg = MSG_SHIFT_TIME_UPDATE_ERROR + crewNames;
            this.setToasterState(true, errMsg, false, 6000);
          }
          // shiftQuickUpdateStatus===405 &&
          else if (
            errorData &&
            errorData.skills_cannot_edit &&
            Array.isArray(errorData.skills_cannot_edit)
          ) {
            let skillNames = "";
            let sepVar = "";
            if (errorData.skills_cannot_edit.length > 0) {
              errorData.skills_cannot_edit.forEach((skillId) => {
                skillNames += sepVar + skillId.skill_name;
                sepVar = ", ";
              });
            }
            let msgStr = MSG_SHIFT_SKILL_EDIT_ERROR.replace(
              ",",
              " " + skillNames + ", "
            );
            this.setToasterState(true, msgStr, false);
          } else if (errorData.error && errorData.error === "past_time") {
            let errMsg = MSG_SHIFT_UPDATE_PAST_TIME_ERROR;
            this.setToasterState(true, errMsg, false); // JSON.stringify(errorData)
          } else {
            this.setToasterState(true, MSG_SHIFT_QUICK_UPDATE_ERROR, false);
          }
        }
      } else if (actString === types.OTHER_EXP_LIST_SUCCESS) {
        if (this.state.shiftData.shiftId === "") {
          this.setState({
            otherExpMultiList: this.formatOtherExpData(otherExps),
          });
        }
      } else if (actString === types.SHIFT_CALC_DISTANCE_DEPT_LOC_SUCCESS || actString === types.SHIFT_CALC_DISTANCE_DEPT_LOC_ERROR) { 
        
        let includeTravelCost = shiftData.travel_cost_details?.minimum_travel_distance && parseFloat(shiftData.travel_cost_details.minimum_travel_distance) > parseFloat(travelModuleDistanceData.distance_miles) ? false : true;

        let travelDistance = travelModuleDistanceData?.distance_miles && parseFloat(travelModuleDistanceData.distance_miles) > 0 ? Math.ceil(parseFloat(travelModuleDistanceData.distance_miles)) : 0; 

        // ADD TRAVEL COST ROUND OFF CONFIGURATION TO TRAVEL TIME 
        let tmHHMM = travelModuleDistanceData?.duration_hh_mm ? parseFloat(travelModuleDistanceData.duration_hh_mm) : 0.00;

        let hours1 = Math.floor(tmHHMM);
        let minutes1 = Math.round((tmHHMM % 1) * 100);
        let hours2 = 0, minutes2 = 0; 

        if(shiftData.travel_cost_details?.travel_time_rounding) { 
          let tmHHMM2 = parseFloat(shiftData.travel_cost_details.travel_time_rounding.replace(':','.'));
          hours2 = Math.floor(tmHHMM2);
          minutes2 = Math.round((tmHHMM2 % 1) * 100);
        }

        let tmpTravelMinutes = (minutes1 + minutes2);
        // ROUND THE MINUTES TO 00, 15, 30 OR 45
        let travelMinutes = (tmpTravelMinutes <= 15) ? 15 : (tmpTravelMinutes <= 30) ? 30 : (tmpTravelMinutes <= 45) ? 45 : 60; 
        let travelHours = hours1 + hours2 + Math.floor(travelMinutes / 60);
        travelMinutes = travelMinutes % 60; 

        travelHours = travelHours > 9 ? travelHours.toString() : ('0'+travelHours.toString()); 
        travelMinutes = travelMinutes > 9 ? travelMinutes.toString() : ('0'+travelMinutes.toString()); 

        let recreatedCalled = false; 
        this.setState({
          travelModuleIncluded: this.state.uncheckIncludeTravelCost ? false : includeTravelCost,
          uncheckIncludeTravelCost: false, 
          shiftData: {
            ...shiftData,
            travel_cost_details: {
              ...shiftData.travel_cost_details,
              travel_distance_miles: parseFloat(travelDistance),
              travel_duration_hh_mm: parseFloat((travelHours.toString()+'.'+travelMinutes.toString())),
            }
        }}, () => {
          if(this.state.uncheckIncludeTravelCost) {
            recreatedCalled = true;
          }
          else {
            this.recreateTravelStaffRows(); 
            recreatedCalled = true; 
          }
          
        });

        if (!recreatedCalled) {
          setTimeout(() => {
            this.recreateTravelStaffRows();
          }, 150);
        }
        
      } else if (actString === types.CREW_AFFILIATE_SKILL_LIST_SUCCESS) {
        if (
          this.state.editShiftId !== 0 &&
          this.state.editShiftId !== undefined
        ) {
          this.props.shiftEditAction(this.state.editShiftId);
          this.setState({ editShiftId: 0 });
        }
        if (this.state.shiftData.shiftId === "") {
          let filteredSkillList = skillList.filter((x) => x.is_active === true);
          this.setState({
            skillMultiList: this.formatSkillData(filteredSkillList),
          });
        }
      } else if (actString === types.SHIFT_ADD_SUCCESS) {
        if (
          shiftAddData.repeat_shift_count === undefined &&
          this.state.isSaveNew === true
        ) {
          this.setToasterStateModal(true, MSG_SHIFT_ADDED, true);
        } else if (this.state.isSaveNew === true) {
          let msg =
            MSG_SHIFT_TOTAL_MSG +
            " " +
            shiftAddData.repeat_shift_count +
            " " +
            MSG_SHIFT_REPEAT_ADDED;
          this.setToasterStateModal(true, msg, true);
        }

        if (this.state.isSaveNew === false) {
          if (
            !isClientPage &&
            this.props.calledFrom &&
            this.props.calledFrom === "eventList"
          ) {
            this.props.callEventDetailsWithPreviewQuote(
              this.props.eventDataForShift.eventId
            );
          }
          if (
            !isClientPage &&
            this.props.eventDataForShift.eventId &&
            this.props.callPreviewQuote
          )
            this.props.callPreviewQuote(this.props.eventDataForShift.eventId);
          this.closeShiftModal();
        } else {
          this.setState({ shiftRepeatData: [] }, () => {
            shiftData["shiftTitle"] = this.props.eventDataForShift.eventTitle
              ? this.props.eventDataForShift.eventTitle + " Shift"
              : "Shift";
            shiftData["shiftLength"] = "08:00";
            shiftData["isShiftRepeat"] = false;
            shiftData["shiftRepeat"] = [];
            shiftData["skillsRate"] = null;
            shiftData["otherExpCost"] = [];
            shiftData["numResource"] = 0;
            shiftData["numCrewChief"] = 0;
            shiftData["shiftNotes"] = "";
            let filteredSkillList = skillList.filter(
              (x) => x.is_active === true
            );
            this.setState(
              {
                shiftRepeatData: shiftRepeatDataMaster,
                shiftData,
                otherExpMultiList: this.formatOtherExpData(otherExps),
                skillMultiList: this.formatSkillData(filteredSkillList),
              },
              () => {
                if (
                  this.state.isSaveNew === true &&
                  this.props.eventDataForShift.eventId
                ) {
                  this.props.getNextShiftSeqNumberAction(
                    this.props.eventDataForShift.eventId
                  );
                }
              }
            );
          });
        }
        this.props.reloadEventList();
        this.props.eventSummaryAction(shiftAddData.result[0].event);
        this.props.eventQuoteSummaryAction(shiftAddData.result[0].event);
      } else if (actString === types.SHIFT_ADD_ERROR) {
        let errMsg = MSG_SHIFT_ADD_ERROR;
        if (errorData.error && errorData.error === "past_time")
          errMsg = MSG_SHIFT_UPDATE_PAST_TIME_ERROR;
        this.setToasterState(true, errMsg, false); // JSON.stringify(errorData)
      } else if (actString === types.SHIFT_EDIT_SUCCESS) {
        let allSkill = [];
        let allExpense = [];
        let actSkillData = [];
        let actOtherExpData = [];

        let disableShiftEdit = false;
        if (isClientPage) {
          disableShiftEdit =
            shiftEditDisable(shiftDetails.status) ||
            shiftDetails.total_requested_crews > 0;
        } else {
          disableShiftEdit = shiftEditDisable(shiftDetails.status);
        }

        if (skillList.length > 0) {
          skillList.forEach((item, index) => {
            const skillExist = shiftDetails.shift_skills.some(
              (skill) => skill.skill.id === item.id
            );
            if (skillExist) {
              const filteredSkill = shiftDetails.shift_skills.filter(
                (x) => x.skill.id === item.id
              );
              allSkill.push({
                value: filteredSkill[0].skill.id,
                label: filteredSkill[0].skill.skill_name,
                inputVal: Number(filteredSkill[0].count),
                inputValTwo: Number(filteredSkill[0].chiefs_required),
                checkDisable: disableShiftEdit ? true : false,
              });
              actSkillData.push({
                skill: item.id,
                count: filteredSkill[0].count,
                chiefs_required: filteredSkill[0].chiefs_required,
              });
            } else {
              if (item.is_active === true) {
                allSkill.push({
                  value: item.id,
                  label: item.skill_name,
                  checkDisable: item.rated && !disableShiftEdit ? false : true,
                });
              }
            }
          });
        }

        if (otherExps.length > 0) {
          otherExps.forEach((item, index) => {
            const isExist = shiftDetails.expenses.some(
              (exp) => exp.other_expense === item.id
            );
            if (isExist) {
              const filtered = shiftDetails.expenses.filter(
                (x) => x.other_expense === item.id
              );
              allExpense.push({
                value: item.id,
                label: titleCase(item.name),
                info: item.short_description,
                inputVal: filtered[0].cost,
                checkDisable: isClientPage || disableShiftEdit ? true : false,
              });
              actOtherExpData.push({
                other_expense: item.id,
                cost: parseInt(filtered[0].cost, 10),
              });
            } else {
              allExpense.push({
                value: item.id,
                label: titleCase(item.name),
                info: item.short_description,
                checkDisable: isClientPage || disableShiftEdit ? true : false,
              });
            }
          });
        }

        // let sTitle = shiftDetails.title.substring(0, shiftDetails.title.indexOf('#'));

        shiftData["shiftId"] = isDuplicate ? "" : shiftDetails.id;
        // shiftData['shiftTitle'] = isDuplicate?'Shift':sTitle;
        shiftData["shiftTitle"] = shiftDetails.title;
        shiftData["eventId"] = shiftDetails.event;
        shiftData["isSameEventLocation"] = shiftDetails.same_as_event_location;

        if (shiftDetails.shift_location_details !== null) {
          shiftData["locationId"] = shiftDetails.shift_location_details.id;
          shiftData["venueName"] = shiftDetails.shift_location_details.location
            .venue
            ? shiftDetails.shift_location_details.location.venue
            : "";
          shiftData["streetOne"] = shiftDetails.shift_location_details.location
            .street1
            ? shiftDetails.shift_location_details.location.street1
            : "";
          shiftData["streetTwo"] = shiftDetails.shift_location_details.location
            .street2
            ? shiftDetails.shift_location_details.location.street2
            : "";
          shiftData["city"] = shiftDetails.shift_location_details.location.city
            ? shiftDetails.shift_location_details.location.city
            : "";
          shiftData["state"] = shiftDetails.shift_location_details.location
            .state
            ? shiftDetails.shift_location_details.location.state
            : "";
          shiftData["country"] = shiftDetails.shift_location_details.location
            .country
            ? shiftDetails.shift_location_details.location.country
            : "";
          shiftData["postcode"] = shiftDetails.shift_location_details.location
            .postcode
            ? shiftDetails.shift_location_details.location.postcode
            : "";
        } else {
          shiftData["venueName"] = "";
          shiftData["streetOne"] = "";
          shiftData["streetTwo"] = "";
          shiftData["city"] = "";
          shiftData["state"] = "";
          shiftData["country"] = "";
          shiftData["postcode"] = "";
        }

        let shift_length = convertDecimalToHHMM(shiftDetails.shift_length);

        // CONVERT DATE AND TIME TO TIMEZONE OF USER'S SETTING
        let timeZone = getUserTimeZone(window.location);
        let sDate = converDateToLocal(
          shiftDetails.start_datetime,
          timeZone.utc_offset,
          "yyyymmddThhmmss",
          "-"
        );
        let eDate = converDateToLocal(
          shiftDetails.end_datetime,
          timeZone.utc_offset,
          "yyyymmddThhmmss",
          "-"
        );
        let arrTime = [];
        arrTime = sDate.split("T");
        let sTime = arrTime[1].substring(0, 5);
        arrTime = eDate.split("T");
        let eTime = arrTime[1].substring(0, 5);

        shiftData["shiftLength"] = shift_length; // isDuplicate?"08:00":shift_length; // shiftDetails.shift_length;
        shiftData["isShiftRepeat"] = false;
        shiftData["startDate"] = sDate;
        shiftData["endDate"] = eDate;
        shiftData["startTime"] = sTime;
        shiftData["endTime"] = eTime;

        shiftData["department"] =
          shiftDetails.department === null ? "" : shiftDetails.department;
        shiftData["keyLocation"] =
          shiftDetails.key_location === null ? "" : shiftDetails.key_location;
        shiftData["affManager"] = shiftDetails.manager;
        shiftData["clientContactStaff"] =
          shiftDetails.contact_staff === null ? "" : shiftDetails.contact_staff;
        shiftData["numResource"] = shiftDetails.resources;
        shiftData["numCrewChief"] = shiftDetails.no_of_chiefs;
        shiftData["shiftNotes"] = isDuplicate ? "" : shiftDetails.shift_notes;
        shiftData["shiftStatus"] = isDuplicate ? 0 : shiftDetails.status;
        shiftData["totalRequestedCrew"] = isDuplicate
          ? 0
          : shiftDetails.total_requested_crews;
        shiftData["skillsRate"] = actSkillData;
        shiftData["otherExpCost"] = actOtherExpData;
        shiftData["seqNumber"] = shiftDetails.seq_no;

        // LOAD TRAVEL COST DETAILS 
        let tmIncluded = false;
        let travelCostData = shiftDetails?.travel_cost_details ? shiftDetails.travel_cost_details : {};
        let travelStaffCount = 0;
        if (travelCostData?.calculation_details && travelCostData.calculation_details.length) {
          tmIncluded = true;
          travelStaffCount = travelCostData.calculation_details.reduce((sum, item) => {
            return sum + (item.staff_per_vehicle * item.no_of_vehicles);
          }, 0);
        }
        travelCostData.total_travel_staff_count = travelStaffCount;

        shiftData["travel_cost_details"] = travelCostData;

        // RESET travelModuleSettings AS PER SHIFT TRAVEL COST DATA 
        let tmSettingsTravelFields = this.state.travelModuleSettings.travel_fields;
        // [ { "id": 3, "field_name": "Rate per miles driven", "field_type": 1, "field_value": 10 } ] - "id" not relevant here

        let shiftTravelFields = travelCostData.travel_fields;
        // [ { "field_id": 1, "field_name": "Rate per miles driven" } ] 

        let newTMSettingsTravelFields = []; 
        // IN SHIFT EDIT RESET THE AFFIILIATE TRAVEL COST SETTINGS VALUES WITH SHIFT DATA
        if(shiftTravelFields && shiftTravelFields.length) {
          newTMSettingsTravelFields = shiftTravelFields.map(shiftField => {
            let fieldRate = travelCostData.calculation_details[0].affiliate_fields.find(fld => (parseInt(fld.field_id,10) === parseInt(shiftField.field_id,10) && parseInt(fld.field_type,10) === parseInt(shiftField.field_type,10))); 
            return (
              {
                field_id: shiftField.field_id,
                field_name: shiftField.field_name,
                field_type: shiftField.field_type,
                field_value: fieldRate.field_rate
              }
            )
          });
        } else { // IF TRAVEL COST NOT ADDED WHILE CREATING THE SHIFT 
          newTMSettingsTravelFields = affiliateTravelSettings.travel_fields;
          
          let originLatLng = null;
          if(this.props?.departments) {
            const dept = this.props.departments.find(d => d.id === shiftDetails.department);
            originLatLng = dept && dept?.key_location_detail?.location?.lat_long ? dept.key_location_detail.location.lat_long : null;
          }
          
          const destLatLng = shiftDetails?.shift_location_details?.location?.lat_long ? shiftDetails.shift_location_details.location.lat_long : null;
          if(originLatLng && destLatLng) { 
            
            this.setState({uncheckIncludeTravelCost:true}); 

            this.props.shiftCalcDistanceDeptLocAction({ originLatLng, destLatLng });
          }
         
          shiftData.travel_cost_details.total_travel_cost= 0; 
          shiftData.travel_cost_details.travel_distance_miles= 0; 
          shiftData.travel_cost_details.travel_duration_hh_mm= 0.0; 
          shiftData.travel_cost_details.total_travel_staff_count= 0; 
          shiftData.travel_cost_details.travel_fields= []; 
          shiftData.travel_cost_details.calculation_details= []; 

        }

        let tmSettings = {
          minimum_travel_distance: travelCostData?.minimum_travel_distance ? travelCostData.minimum_travel_distance : affiliateTravelSettings.minimum_travel_distance,
          staff_per_vehicle: travelCostData?.staff_per_vehicle ? travelCostData.staff_per_vehicle : affiliateTravelSettings.staff_per_vehicle,
          travel_time_rounding: travelCostData?.travel_time_rounding ? travelCostData.travel_time_rounding : affiliateTravelSettings.travel_time_rounding, 
          travel_return_cost_included: travelCostData?.travel_return_cost_included ? travelCostData.travel_return_cost_included : true, 
          travel_fields: newTMSettingsTravelFields
        };

        this.setState(
          {
            skillMultiList: allSkill,
            otherExpMultiList: allExpense,
            shiftData,
            disableLocationSearch: shiftDetails.same_as_event_location,
            shiftActionTitle: isDuplicate ? "Add Shift" : "Edit Shift",
            isSaveBtnEnable: isDuplicate ? true : false,
            formErrors: {
              shiftTitle: "",
              department: "",
              keyLocation: "",
              city: "",
              state: "",
              country: "",
              postcode: "",
              shiftLength: "",
              startDate: "",
              endDate: "",
              startTime: "",
              endTime: "",
              affManager: "",
              clientContactStaff: "",
              numCrewChief: "",
              skillsRate: "",
              otherExpCost: "",
              shiftRepeat: "",
              venueName: "",
            },
            travelModuleIncluded: tmIncluded,
            travelModuleSettings: tmSettings
          },
          () => {
            this.callAffiliateDeptSkillList();
          }
        );
      } else if (actString === types.SHIFT_EDIT_ERROR) {
        let errMsg = MSG_SERVER_DATA_FETCH_ERROR;
        this.setToasterState(true, errMsg, false); // JSON.stringify(errorData)
        // if(errorData.error && errorData.error==='past_time') errMsg = MSG_SHIFT_UPDATE_PAST_TIME_ERROR;
      }
    } 

    if (travelModuleActivity && travelModuleActivity !== prevProps.travelModuleActivity) {
      let arrTM = travelModuleActivity.split("~~");
      if (arrTM[0] === types.AFFILIATE_TRAVEL_SETTINGS_LIST_SUCCESS) {
        let tmpShiftData = this.state.shiftData;
        tmpShiftData.travel_cost_details.minimum_travel_distance = affiliateTravelSettings.minimum_travel_distance;
        tmpShiftData.travel_cost_details.staff_per_vehicle = affiliateTravelSettings.staff_per_vehicle;
        tmpShiftData.travel_cost_details.travel_time_rounding = affiliateTravelSettings.travel_time_rounding;
        tmpShiftData.travel_cost_details.travel_return_cost_included = true;
        this.setState({ shiftData: tmpShiftData, travelModuleSettings: affiliateTravelSettings });
      }
    }
  }

  convertFloatToHHMM = (value) => {
    const num = parseFloat(value);
    const hours = Math.floor(num);
    const minutes = Math.round((num - hours) * 100); // Take decimal as actual minutes

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }

  // TRAVEL TIME FORMAT IN SERVER IS Hr.Mins e.g. '1.05' for '1 hr 5 minutes' and '1.5' for '1 hr 50 mins' 
  calculateTravelHours = (hrsMins) => {
    let tmHHMM = hrsMins ? parseFloat(hrsMins) : 0.00;

    let hours = Math.floor(tmHHMM);
    let minutes = Math.round((tmHHMM % 1) * 100);        

    let travelHours = hours + (minutes / 60);
    return travelHours; 
  }

  render() {
    const {
      clientContacts,
      locations,
      keyLocations,
      assUsers,
      isClientPage,
      shiftSeqNumber,
      departments,
      clientDepartmentsList,
    } = this.props;

    const {
      shiftData,
      otherExpMultiList,
      skillMultiList,
      formErrors,
      initialValidation,
      toastMessage,
      toastFlag,
      toastSuccess,
      shiftActionTitle,
      isSaveBtnEnable,
      toastMessageModal,
      toastFlagModal,
      toastSuccessModal,
      travelModuleSettings,
    } = this.state;

    let selectedStartDate = "";
    let selectedEndDate = "";

    if (shiftData.startDate !== "") {

      if (
        typeof shiftData.startDate == "string" &&
        shiftData.startDate.split("T").length > 1
      ) {
        selectedStartDate = new Date(
          shiftData.startDate.split("T")[0] + "T00:00:00"
        );
        shiftData.startDate = selectedStartDate;
        this.setState({ shiftData: shiftData });
      } else if (typeof shiftData.startDate == "string") {
        selectedStartDate = new Date(shiftData.startDate + "T00:00:00");
      } else {
        selectedStartDate = shiftData.startDate;
      }
    }
    if (shiftData.endDate !== "") {

      if (
        typeof shiftData.endDate == "string" &&
        shiftData.endDate.split("T").length > 1
      ) {
        selectedEndDate = new Date(
          shiftData.endDate.split("T")[0] + "T00:00:00"
        );
        shiftData.endDate = selectedEndDate;
        this.setState({ shiftData: shiftData });
      } else if (typeof shiftData.endDate == "string") {
        selectedEndDate = new Date(shiftData.endDate + "T00:00:00");
      } else {
        selectedEndDate = shiftData.endDate;
      }
    }


    let formattedlocation = [];
    if (locations.length > 0) {
      locations.forEach((el) => {
        el.location["id"] = el.id;
        formattedlocation.push(el.location);
      });
    }

    let clientContactOptions = [];
    if (clientContacts.length > 0) {
      clientContacts.forEach((item) => {
        clientContactOptions.push({
          id: item.id,
          name: item.user.first_name + " " + item.user.last_name,
          firstName: item.user.first_name,
        });
      });
    }

    let selectedContact = clientContactOptions.filter(
      (x) => x.id === shiftData.clientContactStaff
    );

    let disableShiftEdit = false;
    let disableClientFields = false; //disable shift length/Start Time & Address, if the requested crew count > 0 for client
    if (isClientPage) {
      disableShiftEdit = shiftEditDisable(shiftData.shiftStatus);
      disableClientFields = shiftData.totalRequestedCrew > 0;
    } else {
      disableShiftEdit = shiftEditDisable(shiftData.shiftStatus);
    }

    let userGroupData = userGroupUrlCheck(window.location);
    let profileCurrency = "";
    let crew_chief_count = "";
    if (userGroupData !== undefined) {
      profileCurrency = userGroupData.profile_currency;
      crew_chief_count = userGroupData.supervisor_name;
    }
    if (!crew_chief_count) {
      crew_chief_count = LBL_CHIEF_COUNT;
    }

    let eventClientId = this.props.eventDataForShift.clientId
      ? this.props.eventDataForShift.clientId
      : 0;

    // let disableEditAddress =
    //   !DISABLE_LOC_DET_EDIT &&
    //     shiftData.shiftLocation &&
    //     shiftData.shiftLocation.length > 0
    //     ? false
    //     : true;
    let disableEditAddress =
      !DISABLE_LOC_DET_EDIT &&
        shiftData.shiftLocation &&
        shiftData.shiftLocation.length > 0
        ? false
        : false;

    return (
      <>
        <Toast
          toastDescription={toastMessage}
          toastFlag={toastFlag}
          toastSuccess={toastSuccess}
          closeToast={this.onCloseToast}
        />

        <ModalWindow
          ref={this.modalShift}
          header={<CustomModalHeaderStepper activeStep={2} />}
          saveFormData={(e) => this.saveFormData(e)}
          resetModalForm={this.onModalFormReset}

          type="EventAddSave"
          className="custom-modal "
          stepper={true}
          saveNew={shiftData.shiftId !== "" ? 0 : 1}
          saveNewFormData={(e) => this.saveNewFormData(e)}
          isSaveBtnEnable={isSaveBtnEnable}
        >
          <Form autoComplete="off" className="quote-add">
            <Toast
              toastDescription={toastMessageModal}
              toastFlag={toastFlagModal}
              toastSuccess={toastSuccessModal}
              closeToast={this.onCloseToastModal}
            />

            
            <div className="row">
              <CustomTitle title={"Shift Details"} className="mb-4 mx-3" />
              <div className="col-md-6 pr-0">
                <div className="form-group">
                  <label>{LBL_SHIFT + " " + LBL_TITLE} </label>
                  <div
                    className={
                      disableShiftEdit ? "text-optional" : "text-input"
                    }
                  >
                    <input
                      type="text"
                      placeholder=""
                      name="shiftTitle"
                      onChange={this.onHandleChange}
                      className={
                        (formErrors.shiftTitle.length > 0 && initialValidation) ? "input-error" : ""
                      }
                      value={shiftData.shiftTitle || ""}
                      disabled={disableShiftEdit}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-1 shift-seq">
                {/*<div className='text-label'>#{shiftData.shiftId?shiftData.seqNumber:shiftSeqNumber}</div>*/}
              </div>
            </div>
            <div className="row">
              <CustomTitle title={"Shift Address"} className="my-3 mx-3" />
              <div className="col-md-6">
                <label>{LBL_SHIFT + " " + LBL_LOCATION}</label>{" "}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <div className="custom-checkbox">
                    <input
                      type="checkbox"
                      id="samelocevent"
                      name="isSameEventLocation"
                      onChange={this.onLoadSameEventLocation}
                      checked={shiftData.isSameEventLocation}
                      disabled={disableShiftEdit || disableClientFields}
                    />
                    <label className="checkbox" htmlFor="samelocevent"></label>
                    <label className="labeltext" htmlFor="samelocevent">
                      {LBL_SAME_LOC_AS_EVENT}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <div className="custom-checkbox">
                    <input
                      type="checkbox"
                      id="noLocationFound"
                      name="noLocationFound"
                      onChange={this.onGetGoogleLoc}
                      checked={shiftData.noLocationFound}
                      disabled={this.state.disableLocationSearch}
                    />
                    <label
                      className="checkbox"
                      htmlFor="noLocationFound"
                    ></label>
                    <label className="labeltext" htmlFor="noLocationFound">
                      {LBL_LOC_GET_GOOGLE}
                      <sup>
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 400 }}
                          overlay={this.renderTooltip(LBL_TYPE_ADDRESS_GOOGLE)}
                        >
                          <button type="button" className="tootltip-btn">
                            <i className="las la-question-circle"></i>
                          </button>
                        </OverlayTrigger>
                      </sup>
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <div
                    className={
                      shiftData.noLocationFound || shiftData.isSameEventLocation
                        ? "hide"
                        : "text-input"
                    }
                  >
                    <AsyncTypeahead
                      isLoading={false}
                      name="location"
                      id="locationSearch"
                      minLength={3}
                      labelKey="location"
                      onChange={(selected) => this.onSelectLocation(selected)}
                      options={formattedlocation}
                      placeholder={LBL_TYPE_A_LOCATION}
                      onSearch={this.props.onsearchLocation}
                      searchText={LBL_SEARCHING}
                      promptText={LBL_TYPE_A_LOCATION}
                      disabled={this.state.disableLocationSearch}
                      ref={(ref) => (this.typeahead = ref)}
                      inputProps={{
                        className:
                          (formErrors.venueName.length > 0 && initialValidation) ? "input-error" : "",
                      }}
                    />
                  </div>
                  <div
                    className={
                      shiftData.noLocationFound &&
                        !shiftData.isSameEventLocation
                        ? "text-input"
                        : "hide"
                    }
                  >
                    <LocationSearchInput
                      name="googleLocation"
                      googleLocSelect={this.googleLocSelect}
                      disabled={this.state.disableLocationSearch}
                      resetGoogleLocation={this.state.resetGoogleLocation}
                      className={
                        (formErrors.venueName.length > 0 && initialValidation) ? "input-error" : ""
                      }
                    />
                  </div>
                  <div
                    className={
                      shiftData.isSameEventLocation ? "text-optional" : "hide"
                    }
                  >
                    <input
                      type="text"
                      placeholder=""
                      value={[
                        shiftData.venueName,
                        shiftData.streetOne,
                        shiftData.streetTwo,
                        shiftData.city,
                        shiftData.state,
                        shiftData.country,
                        shiftData.postcode,
                      ]
                        .filter(Boolean)
                        .join(", ")}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={shiftData.isSameEventLocation ? "row hide" : "row"}>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_VENUE_NAME}</label>
                  <div className="form-group">
                    <div
                      className={
                        !shiftData.noLocationFound
                          ? "text-input text-optional"
                          : "text-input"
                      }
                    >
                      <input
                        type="text"
                        placeholder=""
                        name="venueName"
                        onChange={this.onHandleChange}
                        value={shiftData.venueName || ""}
                        disabled={disableEditAddress}
                      />
                    </div>
                    {/* disabled={!shiftData.noLocationFound}  */}
                  </div>
                </div>
              </div>
            </div>
            <div className={shiftData.isSameEventLocation ? "row hide" : "row"}>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_STREET_1}</label>
                  <div
                    className={
                      disableEditAddress
                        ? "text-input text-optional"
                        : "text-input"
                    }
                  >
                    <input
                      type="text"
                      placeholder=" "
                      name="streetOne"
                      onChange={this.onHandleChange}
                      value={shiftData.streetOne || ""}
                      maxLength={50}
                      disabled={disableEditAddress}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_STREET_2}</label>
                  <div
                    className={
                      disableEditAddress
                        ? "text-input text-optional"
                        : "text-input"
                    }
                  >
                    <input
                      type="text"
                      placeholder=" "
                      name="streetTwo"
                      onChange={this.onHandleChange}
                      value={shiftData.streetTwo || ""}
                      maxLength={50}
                      disabled={disableEditAddress}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={shiftData.isSameEventLocation ? "row hide" : "row"}>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_CITY}</label>
                  <div
                    className={
                      disableEditAddress
                        ? "text-input text-optional"
                        : "text-input"
                    }
                  >
                    <input
                      type="text"
                      placeholder=" "
                      name="city"
                      onChange={this.onHandleChange}
                      value={shiftData.city || ""}
                      maxLength={50}
                      disabled={disableEditAddress}
                      className={
                        (formErrors.city.length > 0 && initialValidation) ? "input-error" : ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_STATE}</label>
                  <div
                    className={
                      disableEditAddress
                        ? "text-input text-optional"
                        : "text-input"
                    }
                  >
                    <input
                      type="text"
                      placeholder=" "
                      name="state"
                      onChange={this.onHandleChange}
                      value={shiftData.state || ""}
                      maxLength={50}
                      disabled={disableEditAddress}
                      className={
                        (formErrors.state.length > 0 && initialValidation) ? "input-error" : ""
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={shiftData.isSameEventLocation ? "row hide" : "row"}>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_COUNTRY}</label>
                  <div
                    className={
                      disableEditAddress
                        ? "text-input text-optional"
                        : "text-input"
                    }
                  >
                    <input
                      type="text"
                      placeholder=" "
                      name="country"
                      onChange={this.onHandleChange}
                      value={shiftData.country || ""}
                      maxLength={50}
                      disabled={disableEditAddress}
                      className={
                        (formErrors.country.length > 0 && initialValidation) ? "input-error" : ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_POST_CODE}</label>
                  <div
                    className={
                      disableEditAddress
                        ? "text-input text-optional"
                        : "text-input"
                    }
                  >
                    <input
                      type="text"
                      placeholder=" "
                      name="postcode"
                      onChange={this.onHandleChange}
                      value={shiftData.postcode || ""}
                      maxLength={10}
                      disabled={disableEditAddress}
                      className={
                        (formErrors.postcode.length > 0 && initialValidation) ? "input-error" : ""
                      }
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className={"row"}>
              <CustomTitle title={LBL_DEPARTMENT} className="my-3 mx-3" />
              <div className="col-md-12">
                <div className="form-group">
                  <label>{LBL_DEPARTMENT}</label>
                  <div
                    className={
                      disableShiftEdit
                        ? "form-group select-input text-optional"
                        : "form-group select-input"
                    }
                  >
                    <select
                      onChange={this.onHandleChange}
                      name="department"
                      className={
                        (formErrors.department.length > 0 && initialValidation) ? "input-error" : ""
                      }
                      // value={shiftData.department || departments[0]?.id ||clientDepartmentsList[0]?.id || ""}
                      value={shiftData.department || ""}
                      disabled={disableShiftEdit}
                    >
                      <option value="" data-loc="">
                        {LBL_SELECT}
                      </option>
                      {departments &&
                        Array.isArray(departments) &&
                        departments.map((item) => (
                          <option
                            key={item.id}
                            value={item.id}
                            data-loc={item.key_location}
                            lat_long={item.key_location_detail.location.lat_long}
                          >
                            {item.name}
                          </option>
                        ))}
                      {clientDepartmentsList &&
                        Array.isArray(clientDepartmentsList) &&
                        clientDepartmentsList.map((item) => (
                          <option
                            key={item.id}
                            value={item.id}
                            data-loc={item.key_location}
                            lat_long={item.key_location_detail.location.lat_long}
                          >
                            {item.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6 hide">
                <div className="form-group">
                  <label>{LBL_KEY_LOCATION}</label>
                  <div
                    className={
                      disableShiftEdit
                        ? "form-group select-input text-optional"
                        : "form-group select-input"
                    }
                  >
                    <select
                      onChange={this.onHandleChange}
                      name="keyLocation"
                      value={shiftData.keyLocation || ""}
                      className={
                        (formErrors.keyLocation.length > 0 && initialValidation) ? "input-error" : ""
                      }
                      disabled={disableShiftEdit}
                    >
                      <option value="">{LBL_SELECT}</option>
                      {keyLocations.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.location.location}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <CustomTitle title={"Shift Time"} className="my-3 mx-3" />
              <div className="col-md-6">
                <div className="form-group pt-4">
                  <div
                    className={
                      shiftData.shiftId === "" ? "custom-checkbox" : "hide"
                    }
                  >
                    <input
                      type="checkbox"
                      id="IsRepeatEvent"
                      name="isShiftRepeat"
                      onChange={this.onHandleChange}
                      checked={shiftData.isShiftRepeat}
                      disabled={
                        shiftData.shiftId === "" ||
                          shiftData.shiftId === undefined
                          ? false
                          : true
                      }
                    />
                    <label className="checkbox" htmlFor="IsRepeatEvent"></label>
                    <label className="labeltext" htmlFor="IsRepeatEvent">
                      {LBL_IS_REPEATING_SHIFT}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    {LBL_SHIFT_LENGTH +
                      " (" +
                      LBL_HOURS_SHORT +
                      ":" +
                      LBL_MINS_SHORT +
                      ")"}
                  </label>
                  {/* <div className={disableShiftEdit?'text-optional':'text-input'}><input type="text" placeholder=" " name="shiftLength" onChange={this.onHandleChange} onBlur={this.onBlurShiftLength} value={shiftData.shiftLength>0&&shiftData.shiftLength<=12?shiftData.shiftLength:''} className={formErrors.shiftLength.length >0 ? "input-error" : ''} disabled={disableShiftEdit} /></div> */}
                  <div
                    className={
                      disableShiftEdit ? "text-optional" : "time-input"
                    }
                  >
                    <Datetime
                      viewMode="time"
                      dateFormat={false}
                      timeFormat={"HH:mm"}
                      inputProps={{
                        placeholder: LBL_SELECT,
                        name: "shiftLength",
                        className:
                          (formErrors.shiftLength.length > 0 && initialValidation)
                            ? "input-error "
                            : "",
                        disabled: disableShiftEdit,
                      }}
                      value={shiftData.shiftLength}
                      onChange={(selected) =>
                        this.onHandleChangeShiftLength(selected)
                      }
                      onBlur={(selected) => this.onBlurTime(selected, 'shiftLength')}
                      //timeConstraints={ENUM_SHIFT_LENGTH_HHMM}
                      timeConstraints={ENUM_MM15}
                    />
                  </div>
                  {this.state.shiftLengthError.length > 1 && (
                    <div className="text-red">
                      <small>{this.state.shiftLengthError}</small>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* <div>{'shiftData.startDate: '+JSON.stringify(this.state.shiftData.startDate)}</div>
         <div>{'selectedStartDate: '+JSON.stringify(selectedStartDate)}</div> */}

            <div className={shiftData.isShiftRepeat ? "row hide" : "row"}>

              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_START_DATE_TIME}</label>
                  <div className="row">
                    <div className="col-md-6">
                      <div
                        className={
                          disableShiftEdit
                            ? "text-optional calendar-input"
                            : "calendar-input"
                        }
                      >
                        <DatePicker
                          selected={selectedStartDate}
                          onChange={(selected) =>
                            this.onStartDateChange(selected, "startDate")
                          }
                          name="startDate"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select"
                          fixedHeight
                          className={
                            (formErrors.startDate.length > 0 && initialValidation) ? "input-error" : ""
                          }
                          disabled={disableShiftEdit}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className={
                          disableShiftEdit ? "text-optional" : "time-input"
                        }
                      >
                        <Datetime
                          viewMode="time"
                          dateFormat={false}
                          timeFormat={"HH:mm"}
                          inputProps={{
                            placeholder: "Select",
                            name: "startTime",
                            className:
                              (formErrors.startTime.length > 0 && initialValidation)
                                ? "input-error"
                                : "",
                            disabled: disableShiftEdit,
                          }}
                          value={shiftData.startTime}
                          onChange={(selected) =>
                            this.onHandleChangeStartTime(selected, "startTime")
                          }
                          onBlur={(selected) => this.onBlurTime(selected, 'startTime')}
                          timeConstraints={ENUM_MM15}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_END_DATE_TIME}</label>
                  <div className="row">
                    <div className="col-md-6">
                      <div
                        className={
                          disableShiftEdit
                            ? "text-optional calendar-input"
                            : "calendar-input"
                        }
                      >
                        <DatePicker
                          selected={selectedEndDate}
                          onChange={(selected) =>
                            this.onStartDateChange(selected, "endDate")
                          }
                          name="endDate"
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="End Date"
                          minDate={selectedStartDate}
                          // maxDate={selectedEndDate}
                          fixedHeight
                          className={
                            (formErrors.startDate.length > 0 && initialValidation) ? "input-error" : ""
                          }
                          disabled={disableShiftEdit}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div
                        className={
                          disableShiftEdit ? "text-optional" : "time-input"
                        }
                      >
                        <Datetime
                          viewMode="time"
                          dateFormat={false}
                          timeFormat={"HH:mm"}
                          inputProps={{
                            placeholder: "Select",
                            name: "endTime",
                            className:
                              (formErrors.endTime.length > 0 && initialValidation)
                                ? "input-error"
                                : "",
                            disabled: disableShiftEdit,
                          }}
                          value={shiftData.endTime
                          }
                          onChange={(selected) =>
                            this.onHandleChangeStartTime(selected, "endTime")
                          }

                          onBlur={(selected) => this.onBlurTime(selected, 'endTime')}
                          timeConstraints={ENUM_MM15}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className={shiftData.isShiftRepeat ? "row" : "row hide"}>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_START_TIME}</label>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="form-group">
                        <div className="time-input ">
                          <Datetime
                            viewMode="time"
                            dateFormat={false}
                            timeFormat={"HH:mm"}
                            inputProps={{
                              placeholder: "Select",
                              name: "startTime",
                              className:
                                (formErrors.startTime.length > 0 && initialValidation)
                                  ? "input-error"
                                  : "",
                            }}
                            value={shiftData.startTime
                            }
                            onChange={(selected) =>
                              this.onHandleChangeStartTime(
                                selected,
                                "startTime"
                              )
                            }
                            onBlur={(selected) => this.onBlurTime(selected, 'startTime')}
                            timeConstraints={ENUM_MM15}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_END_TIME}</label>
                  <div className="row">
                    <div className=" col-md-12">
                      <div className="form-group">
                        <div className="time-input ">

                          <Datetime
                            viewMode="time"
                            dateFormat={false}
                            timeFormat={"HH:mm"}
                            inputProps={{
                              placeholder: "Select",
                              name: "endTime",
                              className: "timepicker",
                            }}
                            value={shiftData.endTime
                            }
                            onChange={(selected) =>
                              this.onHandleChangeStartTime(selected, "endTime")
                            }
                            onBlur={(selected) => this.onBlurTime(selected, 'endTime')}
                            timeConstraints={ENUM_MM15}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className={shiftData.isShiftRepeat ? "row" : "row hide"}>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_DATES}</label>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="calendar-input ">
                          <DatePicker
                            selected={selectedStartDate}
                            onChange={(selected) =>
                              this.onStartDateChange(selected, "startDate")
                            }
                            name="startDate"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Select"
                            fixedHeight
                            className={
                              (formErrors.startDate.length > 0 && initialValidation)
                                ? "input-error"
                                : ""
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <div className="calendar-input">
                          <DatePicker
                            selected={selectedEndDate}
                            onChange={(selected) =>
                              this.onStartDateChange(selected, "endDate")
                            }
                            // onBlur={(selected) => this.onEndDateBlur(selected)}
                            name="endDate"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="End Date"
                            minDate={new Date()}
                            fixedHeight
                            className={
                              (formErrors.endDate.length > 0 && initialValidation) ? "input-error" : ""
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {formErrors.endDate.length > 0 &&
                    formErrors.endDate !== MSG_REQUIRED && (
                      <div className="text-red left-align text-12">
                        {formErrors.endDate}
                      </div>
                    )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{LBL_SHIFT_REPEATS_ON} </label>
                  <div className="form-group multisel_textbox">
                    <div className="form-group select-input skills">
                      <CustomMultiSelect
                        data={this.state.shiftRepeatData}
                        isFloat={false}
                        onChange={(selected) =>
                          this.onShiftRepeatDataChange(selected)
                        }
                        isTextBox={false}
                        classValue={
                          (formErrors.shiftRepeat.length > 0 &&
                            formErrors.shiftRepeat !== MSG_REQUIRED && initialValidation)
                            ? "input-error"
                            : ""
                        }
                        needSelectAll={true}
                      />
                      {formErrors.shiftRepeat.length > 0 &&
                        formErrors.shiftRepeat !== MSG_REQUIRED && (
                          <div className="text-red left-align text-12">
                            {formErrors.shiftRepeat}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <CustomTitle title={"Resources"} className="my-3 mx-3" />
            </div>

            <div className="w-100 d-flex justify-content-between">
              <div className="">
                <table className="resource-table ">
                  <thead>
                    <tr>
                      <th scope="col">{LBL_SKILLS}</th>
                      <th scope="col">{LBL_REQ_CREW_COUNT}</th>
                      <th scope="col">{crew_chief_count}{shiftData.maxCrewChiefNum > 0
                        ? "(" +
                        LBL_MAX_SUGGESTED +
                        " " +
                        shiftData.maxCrewChiefNum +
                        ")"
                        : ""}</th>
                      {shiftData.skillsRate && !disableShiftEdit && shiftData.skillsRate.length > 1 && <th scope="col"></th>}
                    </tr>
                  </thead>
                  <tbody>
                    {shiftData.skillsRate && shiftData.skillsRate.length > 0 ? (
                      shiftData.skillsRate.map((item, index) => (
                        <tr key={'skillItem'+index}>
                          <td style={{ position: "relative" }}>
                            <div className="select-input">
                              <select
                                name="affManager"
                                onChange={(e) => this.onSelectSkill(e, 'skill', index)}
                                value={item.skill}
                                className={
                                  (formErrors.skillsRate.length > 0 && initialValidation) ? "input-error" : ""
                                }
                                disabled={disableShiftEdit}
                              >
                                <option value="0">{LBL_SELECT}</option>
                                {skillMultiList.map((item) => (
                                  <option
                                    key={item.value}
                                    value={item.value}
                                    disabled={(item.checkDisable) || shiftData.skillsRate.some((skillObj) => Number(skillObj.skill) === Number(item.value))}
                                  >
                                    {item.label}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </td>
                          <td>
                            {" "}
                            <input
                              type={"number"}
                              onChange={(e) => this.onSelectSkill(e, 'count', index)}
                              value={parseInt(item.count, 10) == 0 ? "" : item.count}
                              className={
                                (formErrors.skillsRate.length > 0 && initialValidation) ? "input-error" : ""
                              }
                              disabled={((disableShiftEdit) || (item.skill > 0 ? false : true))}
                              placeholdertext={parseInt(item.count, 10) == 0 ? "" : item.count}
                              min={1}
                              max={999}
                            />
                          </td>
                          <td>
                            {" "}
                            <input
                              type="number"
                              onChange={(e) => this.onSelectSkill(e, 'chiefs_required', index)}
                              value={parseInt(item.chiefs_required, 10) == 0 ? "" : item.chiefs_required}
                              disabled={((disableShiftEdit) || (item.skill > 0 ? false : true))}
                              placeholdertext={parseInt(item.chiefs_required, 10) == 0 ? "" : item.chiefs_required}
                              min={0}
                              max={999}
                            />
                          </td>
                          {shiftData.skillsRate && !disableShiftEdit && shiftData.skillsRate.length > 1 && <td
                            className="text-nowrap "
                            style={{
                              cursor: "pointer",
                              color: "#406C85",
                              fontSize: "12px",
                            }}
                            onClick={() => this.handleSkillsRateUpdate("delete", index)}
                          >
                            {" "}
                            <img src={deleteIcon} className="mb-1" /> {LBL_DELETE}
                          </td>}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td style={{ position: "relative" }}>
                          <div className="select-input">
                            <select
                              name="affManager"
                              defaultValue={0}
                              value={0}
                              onChange={(e) => this.onSelectSkill(e, 'skill', 0)}
                              className={
                                (formErrors.skillsRate.length > 0 && initialValidation) ? "input-error" : ""
                              }
                            >
                              <option value={0}>{LBL_SELECT}</option>
                              {skillMultiList.map((item) => (
                                <option
                                  key={item.value}
                                  value={item.value}
                                  disabled={item.checkDisable}
                                >
                                  {item.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </td>
                        <td>
                          {" "}
                          <input type="number" value={"0"} disabled={true} />
                        </td>
                        <td>
                          {" "}
                          <input type="number" value={"0"} disabled={true} />
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {Array.isArray(skillMultiList) && !disableShiftEdit && Array.isArray(shiftData?.skillsRate) && skillMultiList.length > shiftData.skillsRate.length && (
                  <div>
                    <div className="btn-add-new mt-2" onClick={() => this.handleSkillsRateUpdate("add")}>
                      <img src={addIcon} alt="Add" /> {LBL_BTN_ADDNEW}
                    </div>
                  </div>
                )}

              </div>
              <div className="d-flex w-25 flex-column align-items-center ">
                <label className="text-center text-nowrap">
                  {LBL_TOT_NUM_RESOURCES}
                </label>
                <div className={"confirmed h-center center-align"}>
                  <span className="status-fill font-18 center-align">
                    {" "}
                    &nbsp; {shiftData.numResource} &nbsp;
                  </span>
                </div>
                {/* <div className="text-input text-optional"><input type="text" placeholder=" " name="numResource" value={shiftData.numResource}  disabled /></div> */}
              </div>
            </div>

            {/* **************************************************************************************
            *************************** TRAVEL MODULE - CLIENT LOGIN - START *************************
            ****************************************************************************************** */}
            {isClientPage && shiftData.numResource > 0 && shiftData.department && travelModuleSettings && Array.isArray(travelModuleSettings.travel_fields) && travelModuleSettings.travel_fields.length > 0 && this.state.travelModuleIncluded && this.state.shiftData.travel_cost_details.total_travel_cost ?
              <>
                <div className={"row margin-top-15"} >
                  <CustomTitle title={LBL_TRAVEL_MODULE} className="my-2 mx-3" />
                  <div className="col-md-12 div-flex">
                    <div className="small" >{LBL_TOTAL_TRAVEL_COST + ': ' + profileCurrency + ' ' + (this.state.shiftData.travel_cost_details.total_travel_cost).toFixed(2)}</div>
                  </div>
                </div>
              </> : <></>
            }
            {/* **************************************************************************************
            *************************** TRAVEL MODULE - CLIENT LOGIN - END ***************************
            ****************************************************************************************** */}

            <div
              className={
                isClientPage && shiftData.shiftId === "" ? "row" : "hide"
              }
            >
              <div className="col-md-6 my-4">

                <label>{LBL_CONTACT_FROM_CLIENT}</label>
                {!disableShiftEdit && eventClientId > 0 && (
                  <div className="float-right">
                    <label>
                      <Link
                        onMouseDown={(e) =>
                          this.openAddNewContact(eventClientId)
                        }
                        to="#"
                      >
                        {"+ " + LBL_ADD_NEW_CONTACT}
                      </Link>
                    </label>
                  </div>
                )}
                <div>
                  <Typeahead
                    selected={selectedContact}
                    id="client-contact"
                    labelKey="name"
                    options={clientContactOptions}
                    placeholder={LBL_CHOOSE_A_CONTACT}
                    inputProps={{
                      name: "clientContactStaff",
                      disabled: disableShiftEdit,
                    }}
                    onChange={(s) => this.handleClientContactChange(s)}
                    onInputChange={this.handleRemoveContact}
                  >
                    {({ onClear, selected }) => (
                      <div className="rbt-aux">
                        {!!selected.length && (
                          <ClearButton onClick={this.handleRemoveContact} />
                        )}
                      </div>
                    )}
                  </Typeahead>
                </div>
              </div>
            </div>

            {/* ***********************************************************************************
            *************************** TRAVEL MODULE - AFFILIATE - START *************************
            *************************************************************************************** */}
            {/* // && shiftData.department && travelModuleSettings && Array.isArray(travelModuleSettings.travel_fields) && travelModuleSettings.travel_fields.length > 0  */}

            {!isClientPage && shiftData.numResource > 0 && shiftData.department && travelModuleSettings && Array.isArray(travelModuleSettings.travel_fields) && travelModuleSettings.travel_fields.length > 0 ?
              <>
              
                <div className={"row margin-top-15"} >
                  <CustomTitle title={LBL_TRAVEL_MODULE} className="my-2 mx-3" />

                  <div className="col-md-12 div-flex">
                    <div className=" ">
                      <div className="" >
                            {shiftData.travel_cost_details?.travel_distance_miles && travelModuleSettings?.minimum_travel_distance && parseFloat(shiftData.travel_cost_details.travel_distance_miles) >= parseFloat(travelModuleSettings.minimum_travel_distance) ?
                              <OverlayTrigger
                                placement="top"
                                delay={{ show: 250, hide: 400 }}
                                overlay={this.renderTooltip(LBL_MIN_DIST_EXCEEDED)}
                              >
                                <div className="custom-checkbox" >
                                  <input
                                    type="checkbox"
                                    id="chk-travel-module"
                                    name="chk-travel-module"
                                    onChange={this.onTravelModule}
                                    checked={this.state.travelModuleIncluded}
                                    disabled={disableShiftEdit || disableClientFields}
                                  />
                                  <label className="checkbox" htmlFor="chk-travel-module" ></label>
                                  <label className="labeltext" htmlFor="chk-travel-module" >{LBL_ADD_TRAVEL_MODULE}</label>
                                </div>
                              </OverlayTrigger>
                              : <>
                                <div className="custom-checkbox" >
                                  <input
                                    type="checkbox"
                                    id="chk-travel-module"
                                    name="chk-travel-module"
                                    onChange={this.onTravelModule}
                                    checked={this.state.travelModuleIncluded}
                                    disabled={disableShiftEdit || disableClientFields}
                                  />
                                  <label className="checkbox" htmlFor="chk-travel-module" ></label>
                                  <label className="labeltext" htmlFor="chk-travel-module" >{LBL_ADD_TRAVEL_MODULE}</label>
                                </div>
                            </>}
                      </div>
                    </div>

                    {this.state.travelModuleIncluded ? <div className=" ">
                      <div className="custom-checkbox" >
                        <input
                          type="checkbox"
                          id="chk-return-cost-uncluded"
                          name="chk-return-cost-uncluded"
                          onChange={(e) => this.handleTravelCostFieldsChange(
                            'travel_return_cost_included',
                            0,
                            0,
                            e.target.checked 
                          )
                          }
                          checked={shiftData.travel_cost_details.travel_return_cost_included}
                          disabled={disableShiftEdit || disableClientFields}
                        />
                        <label className="checkbox" htmlFor="chk-return-cost-uncluded" ></label>
                        <label className="labeltext" htmlFor="chk-return-cost-uncluded" >{LBL_TM_INCLUDE_RETURN_COST}</label>
                      </div>
                    </div> : <></> }

                    <div className="travel-time-input div-flex-left">
                      <div className={ disableShiftEdit ? "text-optional time-input div-flex-left form-group" : "time-input div-flex-left form-group" }>
                        <label className="labeltext padding-right-5 padding-top-5"> {LBL_TRAVEL_TIME + ': '} </label>
                        <div className="row">
                          <div className=" col-md-12">
                            <div className="form-group">
                              <div className="time-input ">
                                <Datetime
                                  viewMode="time"
                                  dateFormat={false}
                                  timeFormat={"HH:mm"}
                                  inputProps={{
                                    placeholder: LBL_SELECT,
                                    name: "travelTime",
                                    disabled: disableShiftEdit,
                                    className: "timepicker input-small-80 ",
                                  }}
                                  value={this.convertFloatToHHMM(shiftData.travel_cost_details.travel_duration_hh_mm)}
                                  onChange={(selected) => this.onHandleChangeTravelTime(selected)}
                                  onBlur={(selected) => this.onBlurTime(selected, 'travel_duration_hh_mm')} 
                                  timeConstraints={ENUM_MM15}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className=" ">
                      <div >
                        <label className="labeltext">
                          {LBL_DISTANCE_TO_LOCATION + ': '} <input type="number" value={shiftData.travel_cost_details.travel_distance_miles} onChange={(e) => this.handleTravelCostFieldsChange(
                            'travel_distance_miles',
                            0,
                            0,
                            parseFloat(e.target.value)
                          )
                          } 
                          className="input-small-80" 
                          style={{width: '55px', minWidth: '55px', textAlign: 'right', min: 0, max:999}}  /> {LBL_MILES}
                        </label>
                      </div>
                    </div>

                  </div>
                </div>

                <div className="w-100 d-flex justify-content-between margin-top-15" >

                  {this.state.travelModuleIncluded ? <> <table className="resource-table w-100 table-fixed">
                    <thead>
                      <tr>
                        <th scope="col" className="center-align padding-y-10 px-2 " style={{ width: '75px' }}>{LBL_SLNUM}</th>
                        {travelModuleSettings.travel_fields.map(tmField => {
                          return <th key={'tmField'+tmField.id} scope="col" className="center-align padding-y-10 px-2 text-wrap">{tmField.field_name}</th>
                        })}
                        <th scope="col" className="center-align padding-y-10 px-2 text-wrap">{LBL_TM_STAFF_PER_VEHICLE}</th>
                        <th scope="col" className="center-align padding-y-10 px-2 text-wrap">{LBL_TM_NUM_OF_VEHICLE}</th>
                        <th scope="col" className="center-align padding-y-10 px-2 text-wrap">{LBL_TM_TOTAL + ' (' + profileCurrency + ')'}</th>
                        <th scope="col" className="center-align padding-y-10 px-2 text-wrap">{LBL_TM_ACTION}</th>
                      </tr>

                    </thead>
                    <tbody>
                      {this.state.shiftData?.travel_cost_details?.calculation_details && this.state.shiftData.travel_cost_details.calculation_details.length === 0 ?
                        <>

                        </>
                        : <>
                          {this.state.shiftData?.travel_cost_details?.calculation_details && this.state.shiftData.travel_cost_details.calculation_details.map((tcITem, calcIndex) => {
                            return <><tr>
                              <td className="center-align labeltext "><small><small>{calcIndex + 1}</small></small></td>
                              {tcITem?.affiliate_fields && tcITem.affiliate_fields.length && tcITem.affiliate_fields.map((fldITem, fieldIndex) => {
                                return (
                                  <td className="p-1">
                                    {" "}
                                    <input type="number" style={{ width: '100%', minWidth: '0px' }} value={fldITem.field_rate} onChange={(e) => this.handleTravelCostFieldsChange(
                                      'affiliate_fields',
                                      calcIndex,
                                      fieldIndex,
                                      parseFloat(e.target.value)
                                    )
                                    } />
                                  </td>
                                )
                              })}

                              <td className="center-align p-1">
                                {" "}
                                <input type="number" style={{ width: '100%', minWidth: '0px'}} value={tcITem.staff_per_vehicle} onChange={(e) => this.handleTravelCostFieldsChange(
                                  'staff_per_vehicle',
                                  calcIndex,
                                  0,
                                  parseFloat(e.target.value) 
                                )} />
                              </td>
                              <td className="center-align p-1">
                                {" "}
                                <input type="number" style={{ width: '100%', minWidth: '0px' }} value={tcITem.no_of_vehicles} onChange={(e) => this.handleTravelCostFieldsChange(
                                  'no_of_vehicles',
                                  calcIndex,
                                  0,
                                  parseFloat(e.target.value) 
                                )} />
                              </td>
                              <td className="right-align labeltext total-column"><small><small>
                                {tcITem?.cost ? tcITem.cost.toFixed(2) : '0.00'}</small></small>
                              </td>

                              <td className="center-align"
                                style={{
                                  cursor: "pointer",
                                  color: "#406C85",
                                  fontSize: "12px",
                                }}
                              >
                                {this.state.shiftData.travel_cost_details.calculation_details.length > 1 ? <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={this.renderTooltip(LBL_DELETE)}
                                ><div onClick={() => this.onTravelCostDeleteRow(calcIndex)} ><img src={deleteIcon} alt={LBL_DELETE} className="mb-1 margin-left-10" /> {LBL_DELETE} </div></OverlayTrigger> : <></>}

                              </td>
                            </tr>
                            </>
                          })}

                          {/* **************** TOTAL TRAVEL COST ROW - START **************** */}
                          {this.state.shiftData?.travel_cost_details?.calculation_details && this.state.shiftData.travel_cost_details.calculation_details.length > 0 ?
                            <><tr>
                              <td className="right-align labeltext total-column" colSpan={(travelModuleSettings.travel_fields.length + 3)}><small>{LBL_TOTAL_TRAVEL_COST}: </small></td>
                              <td className="right-align labeltext total-column"><small>
                                {this.state.shiftData.travel_cost_details.total_travel_cost ? this.state.shiftData.travel_cost_details.total_travel_cost.toFixed(2): '0.00'}</small>
                              </td>
                              <td >&nbsp;</td>
                            </tr>
                            </> : <></>}
                          {/* **************** TOTAL TRAVEL COST ROW - END ****************** */}

                        </>}

                    </tbody>
                  </table>

                  </> : <></>}

                  {/* {shiftData.skillsRate && !disableShiftEdit && shiftData.skillsRate.length > 1 &&  */}


                </div>
                <div>
                  {this.state.travelModuleIncluded && shiftData.numResource > this.state.shiftData.travel_cost_details.total_travel_staff_count ? <div className="btn-add-new mt-2" onClick={() => this.onTravelCostAddNewRow()}>
                    <img src={addIcon} alt="Add" /> {LBL_BTN_ADDNEW}
                  </div> : <></>}
                </div>
              </> : <> </>}

            {/* ***********************************************************************************
            *************************** TRAVEL MODULE - AFFILIATE - END ***************************
            *************************************************************************************** */}

            <div
              className={
                isClientPage && shiftData.shiftId === "" ? "row hide" : "row"
              }
            >


              <CustomTitle title={LBL_OTHER} className="my-3 mx-3" />
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    {LBL_OTHER_EXPENSES_COST + " (" + profileCurrency + ")"}
                  </label>
                  <div className="form-group multisel_textbox">
                    <div
                      className={
                        isClientPage || disableShiftEdit
                          ? "text-optional form-group select-input skills"
                          : "form-group select-input skills"
                      }
                    >
                      <CustomMultiSelect
                        data={otherExpMultiList}
                        onChange={(selected) =>
                          this.onOtherExpDataChange(selected)
                        }
                        isFloat={true}
                        isTextBox={true}
                        classValue={
                          (formErrors.otherExpCost.length > 0 && initialValidation)
                            ? "input-error"
                            : ""
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={
                isClientPage && shiftData.shiftId === "" ? "row hide" : "row"
              }
            >
              <div className="col-md-6">
                <div
                  className={
                    isClientPage && shiftData.affManager === ""
                      ? "hide"
                      : "form-group"
                  }
                >
                  <label>{LBL_AFFILIATE_MANAGER}</label>
                  <div
                    className={
                      isClientPage || disableShiftEdit
                        ? "text-optional form-group select-input"
                        : "form-group select-input"
                    }
                  >
                    <select
                      name="affManager"
                      onChange={this.onHandleChange}
                      className={
                        (formErrors.affManager.length > 0 && initialValidation) ? "input-error" : ""
                      }
                      value={shiftData.affManager || ""}
                      disabled={isClientPage || disableShiftEdit}
                    >
                      <option value="0">{LBL_SELECT}</option>
                      {assUsers.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.user.first_name + " " + item.user.last_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6">

                <label>{LBL_CONTACT_FROM_CLIENT}</label>
                {!disableShiftEdit && eventClientId > 0 && (
                  <div className="float-right">
                    <label>
                      <Link
                        onMouseDown={(e) =>
                          this.openAddNewContact(eventClientId)
                        }
                        to="#"
                      >
                        {"+ " + LBL_ADD_NEW_CONTACT}
                      </Link>
                    </label>
                  </div>
                )}
                <div>
                  <Typeahead
                    selected={selectedContact}
                    id="client-contact"
                    labelKey="name"
                    options={clientContactOptions}
                    placeholder={LBL_CHOOSE_A_CONTACT}
                    inputProps={{
                      name: "clientContactStaff",
                      disabled: disableShiftEdit,
                    }}
                    onChange={(s) => this.handleClientContactChange(s)}
                    onInputChange={this.handleRemoveContact}
                  >
                    {({ onClear, selected }) => (
                      <div className="rbt-aux">
                        {!!selected.length && (
                          <ClearButton onClick={this.handleRemoveContact} />
                        )}
                      </div>
                    )}
                  </Typeahead>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>{LBL_SHIFT_NOTES} </label>
                  <textarea
                    rows={"4"}
                    className="form-control"
                    name="shiftNotes"
                    onChange={this.onHandleChange}
                    value={shiftData.shiftNotes}
                  ></textarea>
                </div>
              </div>
            </div>

            
          </Form>
        </ModalWindow>

        {/*CONFIRMED AND STAFF ACCEPTED SHIFT TIME CHANGE - STAFF UNAVAILABILITY MODAL */}
        <ModalWindow
          modalId="shiftTimeChangeModalPopShiftEdit"
          ref={this.shiftTimeChangeModalPopShiftEdit}
          header={this.state.shiftTimeChangeStaffAvailStatus == SHIFT_TIME_CHANGE_ERR_PART_UNAVAILABLE ? LBL_CREW_UNAVAILABLE_PART : this.state.shiftTimeChangeStaffAvailStatus == SHIFT_TIME_CHANGE_ERR_ALL_UNAVAILABLE ? LBL_CREW_UNAVAILABLE_ALL : ''}
          type={'AcceptTimeChange'}
          acceptShiftTimeChange={this.onAcceptShiftTimeChangeConfirm}
          resetModalForm={this.onModalFormResetShiftTimeChange}
          shiftTimeChangeStaffAvailStatus={this.state.shiftTimeChangeStaffAvailStatus}
        >
          <div className="padding-bottom-15">
            {this.state.shiftTimeChangeStaffAvailData.length ? <table className="table border-0" id="eventdata-table">
              <thead className="bg-white">
                <tr className="bt-table">
                  <th>{LBL_SLNUM}</th>
                  <th>{LBL_CREW}</th>
                  <th>{LBL_SKILL}</th>
                  <th>{LBL_STATUS}</th>
                  <th>{LBL_AVAILABILITY}</th>
                </tr>
              </thead>
              <tbody>
                {this.state.shiftTimeChangeStaffAvailData.map((item, index) => {
                  let scheduleShiftStatus = SCHEDULE_CREW_STATUS.filter(x => Number(x.statusCode) === Number(item.schedule_status));
                  return (
                    <tr className="text-centerr" key={index}>
                      <td>{index + 1}</td>
                      <td>{item.crew_name}</td>
                      <td>{item.skill_name}</td>
                      <td>{scheduleShiftStatus[0]?.statusString}</td>
                      <td className={item.available ? '' : ' color-red '}>{item.available ? LBL_AVAILABLE : LBL_UNAVAILABLE}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table> : <></>}
          </div>
        </ModalWindow>
      </>
    );
  }
}

const mapStateToProps = (state) => {

  return {
    otherExps: state.event.otherExps,
    skillList: state.event.skillList,
    subactivity: state.event.subactivity,
    errorData: state.event.errorData,
    crewChiefCount: state.event.crewChiefCount,
    status: state.event.status,
    clientContacts: state.event.clientContacts,
    locations: state.event.locations,
    keyLocations: state.keyLocations.items,
    assUsers: state.event.assUsers,
    shiftDetails: state.event.shiftDetails,
    shiftAddData: state.event.shiftAddData,
    shiftSeqNumber: state.event.shiftSeqNumber,
    departments: state.event.eventClientDepartmentsList,
    eventDeptActivity: state.event.eventDeptActivity,
    clientDeptActivity: state.clients.clientDeptActivity,
    clientDepartmentsList: state.clients.clientDepartmentsList,
    travelModuleDistanceData: state.event.travelModuleDistanceData,
    affiliateTravelSettings: state.travelModule.affiliateTravelSettings,
    travelModuleActivity: state.travelModule.travelModuleActivity,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      otherExpListAction: otherExpListAction,
      shiftAddAction: shiftAddAction,
      eventUpdateShiftAction: eventUpdateShiftAction,
      eventGetCrewChiefCountAction: eventGetCrewChiefCountAction,
      keyLocationListAction: keyLocationListAction,
      quoteAssUserListAction: quoteAssUserListAction,
      crewAffSkillListAction: crewAffSkillListAction,
      clientContactListAction: clientContactListAction,
      shiftEditAction: shiftEditAction,
      eventQuoteSummaryAction: eventQuoteSummaryAction,
      eventSummaryAction: eventSummaryAction,
      getNextShiftSeqNumberAction: getNextShiftSeqNumberAction,
      clientDepartmentsByEventIdAction: clientDepartmentsByEventIdAction,
      clientDepartmentsByClientIdAction: clientDepartmentsByClientIdAction,
      shiftCalcDistanceDeptLocAction: shiftCalcDistanceDeptLocAction,
      affiliateTravelSettingsAction: affiliateTravelSettingsAction
    },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(ShiftAdd);
